<template>
  <v-card flat>
    <v-dialog v-model="failureDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span>Erros</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <div>
          <v-alert :value="true" type="error" style="padding:5px;">
            {{ errors }}
          </v-alert>
        </div>
        <v-card-actions>
          <v-btn color="primary" flat @click="failureDialog = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="infoDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span>Informação</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <div>
          <v-alert :value="true" type="info" color="info" icon="info" style="padding:5px;">
            {{ infos }}
          </v-alert>
        </div>
        <v-card-actions>
          <v-btn color="primary" flat @click="infoDialog = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="table-header">
      <v-card-title>
        <h1 class="titleTable">
          {{ component.text.length > 0 ? component.text : "" }}
        </h1>
        <div
          id="infoConsulta"
          v-if="
            this.logConsulta &&
              ((this.component.tipo != 'emitida' &&
                (component.name.indexOf('NFe') != -1 ||
                  component.name == 'CTE')) ||
                component.name == 'NFSE')
          "
        >
          <small>Última consulta completa em:</small>
          <div id="consultaData">
            <v-icon>calendar_today</v-icon>
            <span>{{ this.logConsulta.toLocaleString() }}</span>
          </div>
        </div>
      </v-card-title>
      <v-card-title>
        <actionsHeader
          :alert="alert"
          :logQtd="logQtd"
          :logConsulta="this.logConsulta"
          :component="component"
          :range="this.range"
          :empresa="empresa"
          :headers="this.table.headers"
          :selected="this.selected"
          :table="this.table"
          :conta="conta"
          @getHeader="getHeader($event)"
          @getLogConsulta="getLogConsulta($event)"
          @getSearch="getSearch($event)"
          @tagForSearch="tagForSearch($event)"
          @updatedSelected="updatedSelected($event)"
          @getDataBusca="getDataBusca($event)"
          @getOpenFiltro="getOpenFiltro($event)"
        ></actionsHeader>

        <panelFiltro
          :mostrar="filtro"
          :table="this.table"
          :component="component"
          :empresa="empresa"
          @getFiltro="getFiltro($event)"
        ></panelFiltro>

        <v-container class="filtros" v-if="table.urlFiltros != ''">
          <v-layout row wrap>
            <div>
              <div id="showFiltrosTitle">Filtrando por</div>
              <div
                id="showFiltrosContent"
                v-for="(item, i) in table.filtros.items"
                v-if="
                  item.valor != null &&
                    item.valor.length > 0 &&
                    table.urlFiltros != ''
                "
                :key="i"
              >
                <strong>{{ item.text }}:</strong>
                <v-chip
                  text-color="white"
                  id="chipFiltros"
                  color="indigo darken-4"
                  v-if="
                    item.item_id != 'status' && item.item_id != 'manifestacao' && item.item_id != 'statusDes'
                  "
                  @click.native="rmvThisFilter(item, undefined, $event)"
                >
                  <small>
                    <span v-if="item.item_id.indexOf('vlr') != -1">R$</span>
                    <span v-if="item.text.toLowerCase().indexOf('data') != -1">{{
                      item.data
                        .split("-")
                        .reverse()
                        .join("/")
                    }}</span>
                    <span v-else>{{ item.valor }}</span>
                  </small>
                  <div class="v-chip__close">
                    <i
                      id="chipFiltrosClose"
                      aria-hidden="true"
                      class="v-icon material-icons"
                      >cancel</i
                    >
                  </div>
                </v-chip>
                <v-chip
                  text-color="white"
                  id="chipFiltros"
                  color="indigo darken-4"
                  @click.native="rmvThisFilter(item, a, $event)"
                  v-if="
                    item.item_id == 'status' || item.item_id == 'manifestacao' || item.item_id == 'statusDes'
                  "
                  v-for="(a, j) in item.valor"
                  :key="j"
                >
                  <small>{{ a }}</small>
                  <div class="v-chip__close">
                    <i
                      id="chipFiltrosClose"
                      aria-hidden="true"
                      class="v-icon material-icons"
                      >cancel</i
                    >
                  </div>
                </v-chip>
              </div>
              <div id="showFiltrosTitle">
                <v-tooltip bottom>
                  <v-btn
                    slot="activator"
                    outline
                    color="teal"
                    text-color="white"
                    dark
                    round
                    id="btn_clsFiltros"
                    :class="'d-inline-block'"
                    style="height: 22px!important; width: 100px;"
                    @click.native="
                      table.resetFiltro(),
                        (table.filtros.fechar = true),
                        getFiltro(),
                        (range = 'mesAtual')
                    "
                  >
                    <v-icon
                      class="material-icons"
                      dark
                      color="orange"
                      style="font-size: 15px;"
                      >delete_forever</v-icon
                    >
                    <small style="padding:2px">Limpar Filtro</small>
                  </v-btn>
                  <span>Limpar todo filtro avançado</span>
                </v-tooltip>
              </div>
            </div>
          </v-layout>
        </v-container>
      </v-card-title>

      <btnMoverTable
        v-if="component.enable.arrowMovTable"
        :table="table"
        :component="this.component"
      ></btnMoverTable>
    </div>
    <v-data-table
      v-model="selected"
      :headers="table.headers"
      :search="search"
      :custom-filter="customFilter"
      :items="table.arrayNotas"
      :pagination.sync="pagination"
      select-all
      item-key="chave"
      class="elevation-1"
      :rows-per-page-text="`${component.textPlural} por página: `"
      :rows-per-page-items="table.rows_per_page_items"
      :loading="table.loading"
      :next="$vuetify.icons.next"
      prev-icon
      next-icon
      id="table"
      :class="'table_' + component.name"
    >
      <v-progress-linear
        slot="progress"
        color="teal"
        height="20"
        indeterminate
        style="z-index: 3;"
      ></v-progress-linear>
      <template slot="headers" slot-scope="props">
        <tr>
          <th
            id="auxFix"
            v-if="component.enable.selectAll || component.enable.acoes"
            :style="
              (component.enable.acoes == false
                ? 'min-width: 30px;max-width: 30px;width: 30px;'
                : '',
              component.enable.selectAll == false &&
              component.enable.acoes == true
                ? 'min-width: 0px;'
                : '')
            "
          ></th>
          <th id="slctBox" v-if="component.enable.selectAll" class="headcol">
            <!-- {{props.indeterminate}} -->
            <v-checkbox
              :input-value="props.all"
              :indeterminate="props.indeterminate"
              primary
              hide-details
              v-on:click="
                selected = table.selecionarTodosItens('primeiro_check')
              "
              @click.native="
                selected = table.selecionarTodosItens('parse').slice()
              "
            ></v-checkbox>
          </th>
          <th
            v-for="header in props.headers"
            :id="'h_' + header.value"
            :key="header.text"
            :style="
              header.value == 'acoes' &&
              component.enable.selectAll == false &&
              component.enable.acoes == true
                ? 'left: 0px'
                : ''
            "
            :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : '',
              header.value == 'acoes' ? 'headcol' : '',
            ]"
            @click="changeSort(header.value)"
            v-show="header.show == true"
            style="color: #25476a; font-weight: 900; font-size: 0.9em; "
          >
            <v-icon v-if="header.value != 'acoes'" style="color: white;" small
              >arrow_upward</v-icon
            >
            {{ header.text }}
            <v-tooltip v-if="header.value == 'CRT'" top style=" cursor: help;">
              <span style="font-size: 13px;" slot="activator" color="black">
                <v-icon
                  style="font-size: 13px; opacity: 1;"
                  class="dont_rotate"
                  slot="activator"
                  color="black"
                  >help</v-icon
                >
              </span>
              <span>
                1 - Simples Nacional.
                <br />2 - Simples Nacional - excesso de sublimite de receita
                bruta. <br />3 - Regime Normal.
                <br />
              </span>
            </v-tooltip>
            <v-tooltip
              v-if="header.value == 'statusIn'"
              top
              style=" cursor: help;"
            >
              <span style="font-size: 13px;" slot="activator" color="black">
                <v-icon
                  style="font-size: 13px; opacity: 1;"
                  class="dont_rotate"
                  slot="activator"
                  color="black"
                  >help</v-icon
                >
              </span>
              <span>
                Ativo - Colaborador ativo no Motor Fiscal.
                <br />Pendente - Acesso Pendente do colaborador no Motor Fiscal.
                <br />Inativo - Colaborador desativado no Motor Fiscal.
                <br />
              </span>
            </v-tooltip>
            <v-tooltip
              v-if="header.value == 'statusErp'"
              top
              style=" cursor: help;"
            >
              <span style="font-size: 13px;" slot="activator" color="black">
                <v-icon
                  tag="div"
                  class="dont_rotate"
                  style="font-size: 13px; opacity: 1;"
                  slot="activator"
                  color="black"
                  >help</v-icon
                >
              </span>
              <span>
                Espaço reservado para
                <strong>informativo</strong>
                <br />de integração com
                <strong>sistemas ERP.</strong>
              </span>
            </v-tooltip>
            <v-tooltip
              v-if="header.value == 'statusErpDois'"
              top
              style=" cursor: help;"
            >
            <span style="font-size: 13px;" slot="activator" color="black">
              <v-icon
                tag="div"
                class="dont_rotate"
                style="font-size: 13px; opacity: 1;"
                slot="activator"
                color="black"
                >help</v-icon
              >
            </span>
            <span>
              Espaço reservado para
              <strong>informativo</strong>
              <br />de integração com
              <strong>sistemas ERP Dois.</strong>
            </span>
            </v-tooltip>
            <v-tooltip
              v-if="header.value == 'posFechamento'"
              top
              style=" cursor: help;"
            >
            <span style="font-size: 13px;" slot="activator" color="black">
              <v-icon
                tag="div"
                class="dont_rotate"
                style="font-size: 13px; opacity: 1;"
                slot="activator"
                color="black"
                >help</v-icon
              >
            </span>
            <span>
              Espaço reservado para
              <strong>informativo</strong>
              <br />de notas emitidas pós o fechamento
              <strong>.</strong>
            </span>
            </v-tooltip>
            <v-tooltip
              v-if="header.value == 'discriminacao'"
              top
              style=" cursor: help;"
            >
              <span style="font-size: 13px;" slot="activator" color="black">
                <v-icon
                  style="font-size: 13px; opacity: 1;"
                  class="dont_rotate"
                  slot="activator"
                  color="black"
                  >help</v-icon
                >
              </span>
              <span>
                Discriminação completa no
                <strong>1º botão da coluna</strong> Ações
              </span>
            </v-tooltip>
            <v-tooltip
              v-if="header.value.indexOf('custom_') != -1"
              top
              style=" cursor: help;"
            >
              <span style="font-size: 15px;" slot="activator" color="white">
                <v-icon
                  style="font-size: 13px; opacity: 1;"
                  class="dont_rotate"
                  slot="activator"
                  color="white"
                  >edit</v-icon
                >
              </span>
              <span>
                Linhas desta coluna são
                <strong>Editáveis</strong>
              </span>
            </v-tooltip>
          </th>
        </tr>
      </template>
      <template slot="items" slot-scope="props" id="el">
        <tr
          :active="props.selected"
          :class="[
            props.item.status != undefined &&
            props.item.status.toLowerCase() == 'cancelada'
              ? 'cancelada'
              : '',
            props.item.statusNFe != undefined &&
            props.item.statusNFe.toLowerCase() == 'cancelada'
              ? 'cancelada'
              : '',
            props.item.manifestacao != undefined &&
            props.item.manifestacao.toLowerCase() == 'desacordo'
              ? 'cancelada'
              : '',
            props.item.statusEmissao != undefined &&
            props.item.statusEmissao.toLowerCase() == 'cancelada'
              ? 'cancelada'
              : '',
          ]"
        >
          <td
            @click="selectRow(props)"
            id="slctBox"
            class="headcol"
            v-if="component.enable.selectAll"
          >
            <v-checkbox
              v-on:click="
                selected = table.selecionarTodosItens('primeiro_check')
              "
              :input-value="props.selected"
              primary
            ></v-checkbox>
          </td>
          <td
            v-if="component.enable.acoes"
            class="text-xs-center headcol"
            id="acoes"
            :class="[component.name == 'fornecedores' ? 'forn' : '']"
            :style="
              (component.name == 'CTE'
                ? ' width: 134px;'
                : 'width: max-content;',
              component.enable.selectAll == false &&
              component.enable.acoes == true
                ? 'left: 0px;'
                : '')
            "
          >
            <columnActions
              :attTableEmp="this && this.attTableEmp"
              @attTableEmp="attTableEmp($event)"
              :alert="alert"
              :conta="conta"
              @emitEditEmp="emitEditEmp($event)"
              :table="table"
              :component="component"
              :nota="props"
              :empresa="empresa"
              :IBGE="IBGE"
            ></columnActions>
          </td>
          <td
            id="auxFix"
            v-if="component.enable.selectAll || component.enable.acoes"
            :style="component.enable.acoes == false ? 'min-width: unset;' : ''"
          ></td>
          <td
            v-for="(item, index) in props.item"
            :key="index"
            :class="[
              index.indexOf('valor') != -1 ||
              index.toLowerCase().indexOf('vlr') != -1 ||
              index.toLowerCase().indexOf('vlr') != -1 ||
              index.toLowerCase().indexOf('pis') != -1 ||
              index.toLowerCase().indexOf('cofins') != -1 ||
              index.toLowerCase().indexOf('csll') != -1 ||
              index.toLowerCase().indexOf('inss') != -1 ||
              index.toLowerCase().indexOf('ir') != -1
                ? 'text-xs-right'
                : index.toLowerCase().indexOf('xprod') != -1 ||
                  index.toLowerCase().indexOf('cprod') != -1 ||
                  index.toLowerCase().indexOf('fornrazao') != -1 ||
                  index.toLowerCase().indexOf('xnome') != -1 ||
                  index.toLowerCase().indexOf('xfant') != -1
                ? 'text-xs-left'
                : 'text-xs-center',
              index.indexOf('custom_') != -1 ? 'customCc' : '',
            ]"
            :id="index"
          >
            <!-- { : 'text-xs-center'} -->
            <span v-if="index == 'protocolada'">
              <v-chip
                v-if="item != undefined && item.toLowerCase() == 'sim'"
                small
                color="green"
                text-color="white"
                >{{ item }}</v-chip
              >
              <v-chip
                v-else-if="item != undefined && item.toLowerCase() == 'nao'"
                small
                color="red"
                text-color="white"
                >{{ item }}</v-chip
              >
            </span>
            <span v-else-if="index == 'ISSRetido'">
              <v-chip
                v-if="item != undefined && item.toLowerCase() == 'true'"
                small
                color="green"
                text-color="white"
                >Sim</v-chip
              >
              <v-chip
                v-else-if="item != undefined && item.toLowerCase() == 'false'"
                small
                color="red"
                text-color="white"
                >Não</v-chip
              >
            </span>
            <span v-else-if="index == 'statusEmissao'">
              <v-tooltip
              right
              v-if="item != undefined && item.toLowerCase() == 'processando'"
              >
              <template v-slot:activator="{ on }">
                <v-chip
                v-on="on"
                small
                color="green"
                text-color="white"
                >
                  <span style="cursor: pointer;">Processando</span>
                </v-chip>

              </template>
              <span>{{
                 props.item.erroEmissao ? props.item.erroEmissao : "Processando"
                }}</span>
              </v-tooltip>

              <v-tooltip
                right
                v-else-if="item != undefined && item.toLowerCase() == 'falha'"
              >
                <template v-slot:activator="{ on }">
                  <v-chip
                    v-on="on"
                    small
                    color="orange"
                    text-color="white"
                    @click="handleFailure(props.item,'EMISSAO')"
                  >
                    <span style="cursor: pointer;">Falha</span>
                  </v-chip>
                </template>
                <span>{{
                  props.item.erroEmissao ? props.item.erroEmissao : "Falha"
                }}</span>
              </v-tooltip>
              <v-chip
                v-else-if="item != undefined && item.toLowerCase() == 'emitido'"
                small
                color="blue"
                text-color="white"
                >Emitido</v-chip
              >
              <v-chip
                v-else-if="
                  item != undefined && item.toLowerCase() == 'inclusao'
                "
                small
                color="grey darken-3"
                text-color="white"
                >Pendente</v-chip
              >
              <v-chip
                v-if="item != undefined && item.toLowerCase() == 'cancelada'"
                small
                color="red"
                text-color="white"
                >Cancelada</v-chip
              >
            </span>
            <span
              v-else-if="
                index != undefined && index.toLowerCase() == 'opcaosimples'
              "
            >
              <colunaSimples
                :component="component"
                :table="table"
                :item="item"
              ></colunaSimples>
            </span>
            <span
              v-else-if="index != undefined && index.toLowerCase() == 'tribnfe'"
            >
              <colunatributacao
                :component="component"
                :table="table"
                :item="props"
              ></colunatributacao>
            </span>
            <span
              v-else-if="index != undefined && index.toLowerCase() == 'lei'"
            >
              <colunalei
                :item="props"
                v-if="props.item.lei != undefined"
              ></colunalei>
            </span>
            <span
              v-else-if="index != undefined && index.toLowerCase() == 'inf_ad'"
            >
              <colunaInfAd :item="props" v-if="props.item.inf_ad"></colunaInfAd>
            </span>
            <span v-else-if="index != undefined && index.toLowerCase() == 'produtos'">
              <colunaProdutos
                :component="component"
                :item="item"
                :empresa="empresa"
              ></colunaProdutos>
            </span>
            <span
              v-else-if="index != undefined && index.toLowerCase() == 'sistem'"
            >
              <colunaSistema
                :item="props"
                v-if="props.item.sistem"
              ></colunaSistema>
            </span>
            <span v-else-if="index == 'status'">
              <v-chip
                v-if="item != undefined && item.toLowerCase() == 'cancelada'"
                small
                color="red"
                text-color="white"
                >{{ item }}</v-chip
              >
              <v-chip
                v-else-if="
                  item != undefined && item.toLowerCase() == 'autorizada'
                "
                small
                color="green"
                text-color="white"
                >{{ item }}</v-chip
              >
            </span>
            <span v-else-if="index == 'modal'">
              <v-chip
                v-if="item != undefined && item.toLowerCase() == '01'"
                small
                color="indigo darken-4"
                text-color="white"
                >Rodoviario</v-chip
              >
              <v-chip
                v-else-if="item != undefined && item.toLowerCase() == '02'"
                small
                color="indigo darken-3"
                text-color="white"
                >Aereo</v-chip
              >
              <v-chip
                v-else-if="item != undefined && item.toLowerCase() == '03'"
                small
                color="indigo darken-2"
                text-color="white"
                >Aquaviario</v-chip
              >
              <v-chip
                v-else-if="item != undefined && item.toLowerCase() == '04'"
                small
                color="deep-purple darken-2"
                text-color="white"
                >Ferroviario</v-chip
              >
              <v-chip
                v-else-if="item != undefined && item.toLowerCase() == '05'"
                small
                color="deep-purple darken-3"
                text-color="white"
                >Dutoviario</v-chip
              >
              <v-chip
                v-else-if="item != undefined && item.toLowerCase() == '06'"
                small
                color="deep-purple darken-4"
                text-color="white"
                >Multimodal</v-chip
              >
            </span>
            <span v-else-if="index == 'trans_modFrete' && item != undefined && item.toLowerCase() == '0' ">
            Por conta do emitente</span>
            <span v-else-if="index == 'trans_modFrete' && item != undefined && item.toLowerCase() == '1' ">
              Por conta do destinatário/remetente</span>
            <span v-else-if="index == 'trans_modFrete' && item != undefined && item.toLowerCase() == '2' ">
              Por conta de terceiros</span>
            <span v-else-if="index == 'trans_modFrete' && item != undefined && item.toLowerCase() == '9' ">
              Sem frete</span>

            <!-- statusNFe -->
            <span v-else-if="index == 'statusNFe'">
              <v-chip
                v-if="item != undefined && item.toLowerCase() == 'cancelada'"
                small
                color="red"
                text-color="white"
                >{{ item }}</v-chip
              >
              <v-chip
                v-else-if="item != undefined && item.toLowerCase() == 'normal'"
                small
                color="green"
                text-color="white"
                >{{ item }}</v-chip
              >
            </span>

            <span v-else-if="index == 'status_escrituracao'">
              <v-chip 
              v-if="item != undefined && item.toLowerCase() == 'escriturada'"
              small
              color="green"
              text-color="white"
              >{{item}}</v-chip>
              

              <v-tooltip
                right
                v-else-if="item != undefined && item.toLowerCase() == 'desconsiderada'"
              >
                <template v-slot:activator="{ on }">
                  <v-chip
                    small
                    v-on="on"
                    color="orange"
                    text-color="white"
                    @click="handleFailure(props.item,'ESCRITURACAO')"
                    >
                        <span style="cursor: pointer;">Desconsiderada</span>
                  </v-chip>
                </template> 
                <span>{{
                  props.item.log_escrituracao ? props.item.log_escrituracao : 'Desconsiderada'
                }}</span>
              </v-tooltip>

              <v-tooltip
                right
                v-else-if="item != undefined && item.toLowerCase() == 'erro'"
              >
                <template v-slot:activator="{ on }">
                  <v-chip
                    small
                    v-on="on"
                    color="red"
                    text-color="white"
                    @click="handleFailure(props.item,'ESCRITURACAO')"
                    >
                        <span style="cursor: pointer;">Erro</span>
                  </v-chip>
                </template> 
                <span>{{
                  props.item.log_escrituracao ? props.item.log_escrituracao : 'Erro'
                }}</span>
              </v-tooltip>
              <v-chip
                v-else-if="!item || item.toLowerCase() == 'pendente'"
                small
                color="#fcf738"
                text-color="black"
                >Pendente</v-chip
              >
              
            </span>
            <span v-else-if="index == 'ftpPython'">
              <v-chip 
              v-if="item != undefined && item.toLowerCase() == 'sucesso'"
              small
              color="green"
              text-color="white"
              >{{item}}</v-chip>

              <v-tooltip
                right
                v-else-if="props.item.logErroFtpXml != undefined && props.item.logErroFtpXml != ''"
              >
                <template v-slot:activator="{ on }">
                  <v-chip
                    small
                    v-on="on"
                    color="red"
                    text-color="white"
                    @click="handleFailure(props.item,'XML')"
                    >
                        <span style="cursor: pointer;">Falha</span>
                  </v-chip>
                </template> 
                <span>{{
                  props.item.logErroFtpXml ? props.item.logErroFtpXml : 'Falha'
                }}</span>
              </v-tooltip>
              <v-chip
                v-else-if="!item || item.toLowerCase() == 'pendente'"
                small
                color="#fcf738"
                text-color="black"
                >Pendente</v-chip
              >
              
            </span>

            <span v-else-if="index == 'ftpPythonPdf'">
              <v-chip 
              v-if="item != undefined && item.toLowerCase() == 'sucesso'"
              small
              color="green"
              text-color="white"
              >{{item}}</v-chip>

              <v-tooltip
                right
                v-else-if="props.item.logErroFtpPdf != undefined && props.item.logErroFtpPdf != ''"
                >
                <template v-slot:activator="{ on }">
                  <v-chip
                    small
                    v-on="on"
                    color="red"
                    text-color="white"
                    @click="handleFailure(props.item,'PDF')"
                    >
                        <span style="cursor: pointer;">Falha</span>
                  </v-chip>
                </template> 
                <span>{{
                  props.item.logErroFtpPdf ? props.item.logErroFtpPdf : 'Falha'
                }}</span>
              </v-tooltip>
              <v-chip
                v-else-if="!item || item.toLowerCase() == 'pendente'"
                small
                color="#fcf738"
                text-color="black"
                >Pendente</v-chip
              >
              
            </span>
            
            <span v-else-if="index == 'statusOcr'">
              <v-chip 
              v-if="item != undefined && item.toLowerCase() == 'sucesso'"
              small
              color="green"
              text-color="white"
              >{{item}}</v-chip>
              <v-tooltip
                right
                v-else-if="item != undefined && item.toLowerCase() == 'falha'"
              >
                <template v-slot:activator="{ on }">
                  <v-chip
                    small
                    v-on="on"
                    color="red"
                    text-color="white"
                    @click="handleFailure(props.item,'OCR')"
                    >
                        <span style="cursor: pointer;">Falha</span>
                  </v-chip>
                </template> 
                <span>{{
                  props.item.log_ocr ? props.item.log_ocr : 'Falha'
                }}</span>
              </v-tooltip>
              <v-chip
              v-else-if="item != undefined && item.toLowerCase() == 'inativo'"
                small
                color="orange"
                text-color="black"
                >{{item}}</v-chip
              >
              <v-chip
                v-else
                small
                color="#fcf738"
                text-color="black"
                >{{item}}</v-chip
              >
              
            </span>

            <span v-else-if="index == 'statusIntegracao'">
              <v-chip 
              v-if="item != undefined && item.toLowerCase() == 'sucesso'"
              small
              color="green"
              text-color="white"
              >{{item}}</v-chip>
              <v-tooltip
                right
                v-else-if="item != undefined && item.toLowerCase() == 'falha'"
              >
                <template v-slot:activator="{ on }">
                  <v-chip
                    small
                    v-on="on"
                    color="red"
                    text-color="white"
                    @click="handleFailure(props.item,'INTEGRACAO')"
                    >
                        <span style="cursor: pointer;">Falha</span>
                  </v-chip>
                </template> 
                <span>{{
                  props.item.log_integracao ? props.item.log_integracao : 'Falha'
                }}</span>
              </v-tooltip>
              <v-chip
                v-else-if="!item || item.toLowerCase() == 'pendente'"
                small
                color="#fcf738"
                text-color="black"
                >{{item}}</v-chip
              >
              
            </span>
            
            <span v-else-if="index === 'vencimento'">{{
              item != undefined && item instanceof Date && !isNaN(item)
                ? item.toLocaleDateString("pt-BR")
                : item
            }}</span>
            <span v-else-if="index === 'createdAt'">{{
              item != undefined && item instanceof Date && !isNaN(item)
                ? item.toLocaleDateString("pt-BR")
                : item
            }}</span>
           

            <span v-else-if="index == 'trabFiliado'">
              <v-chip
                v-if="item != undefined && item.indexOf('nfse') != -1"
                small
                color="primary"
                text-color="white"
                >Serviço</v-chip
              >
              <v-chip
                v-if="item != undefined && item.indexOf('nfe') != -1"
                small
                color="teal"
                text-color="white"
                >Mercadoria</v-chip
              >
            </span>
            <span v-else-if="index == 'manifestacao'">
              <colunaManifestoBtn
                :nota="props"
                :item="item"
                :empresa="empresa"
              ></colunaManifestoBtn>
            </span>
            <span
              v-else-if="index.toLowerCase().indexOf('rela_qntlogins') != -1"
            >
              <colunaLogins
                :component="component"
                :item="props.item"
              ></colunaLogins>
            </span>
            <span v-else-if="index.toLowerCase() === 'statuserp'">

              <v-tooltip
                right
                v-if="item != undefined && item.toLowerCase().indexOf('integrado') != -1"
              >
                <template v-slot:activator="{ on }">
                  <v-chip
                    small
                    v-on="on"
                    color="primary"
                    text-color="white"
                    @click="handleInfo(props.item,'STATUSERP')"
                    >
                        <span style="cursor: pointer;">{{ capitalizeFirstLetter(item) }}</span>
                  </v-chip>
                </template> 
                <span>{{
                  props.item.log_statusErp ? props.item.log_statusErp : capitalizeFirstLetter(item)
                }}</span>
              </v-tooltip>
              <v-tooltip
                right
                v-else-if="item != undefined && item.toLowerCase().indexOf('cancelada') != -1"
              >
                <template v-slot:activator="{ on }">
                  <v-chip
                    small
                    v-on="on"
                    color="primary"
                    text-color="white"
                    @click="handleInfo(props.item,'STATUSERP')"
                    >
                        <span style="cursor: pointer;">{{ capitalizeFirstLetter(item) }}</span>
                  </v-chip>
                </template> 
                <span>{{
                  props.item.log_statusErp ? props.item.log_statusErp : capitalizeFirstLetter(item)
                }}</span>
              </v-tooltip>
              <v-chip
                v-else-if="
                  item &&
                    item != undefined &&
                    item.toLowerCase().indexOf('validada') != -1
                "
                small
                color="orange"
                text-color="white"
                >{{ capitalizeFirstLetter(item) }}</v-chip
              >
              <v-chip
                v-else-if="
                  item &&
                    item != undefined &&
                    item.toLowerCase().indexOf('pre') != -1 &&
                    item.toLowerCase().indexOf('nota') != -1
                "
                small
                color="yellow lighten-2"
                text-color="black"
                >{{ capitalizeFirstLetter(item) }}</v-chip
              >
              <v-chip
                v-else-if="
                  item &&
                    item != undefined &&
                    item.toLowerCase().indexOf('nota') != -1 &&
                    item.toLowerCase().indexOf('classificada') != -1
                "
                small
                color="green"
                text-color="white"
                >{{ capitalizeFirstLetter(item) }}</v-chip
              >
              <v-tooltip
                right
                v-else-if="item != undefined && item.toLowerCase().indexOf('falha') != -1"
              >
                <template v-slot:activator="{ on }">
                  <v-chip
                    small
                    v-on="on"
                    color="red"
                    text-color="white"
                    @click="handleFailure(props.item,'STATUSERP')"
                    >
                        <span style="cursor: pointer;">{{item}}</span>
                  </v-chip>
                </template> 
                <span>{{
                  props.item.log_statusErp ? props.item.log_statusErp : 'Falha'
                }}</span>
              </v-tooltip>
              <v-chip
                v-else-if="item != undefined && item != ''"
                small
                color="grey"
                text-color="white"
                >{{ capitalizeFirstLetter(item) }}</v-chip
              >
            </span>
            <span v-else-if="index.toLowerCase() === 'statuserpdois'">

              <v-tooltip
                right
                v-if="item != undefined && item.toLowerCase().indexOf('integrado') != -1"
              >
                <template v-slot:activator="{ on }">
                  <v-chip
                    small
                    v-on="on"
                    color="primary"
                    text-color="white"
                    @click="handleInfo(props.item,'STATUSERPDOIS')"
                    >
                        <span style="cursor: pointer;">{{ capitalizeFirstLetter(item) }}</span>
                  </v-chip>
                </template> 
                <span>{{
                  props.item.log_statusErpDois ? props.item.log_statusErpDois : capitalizeFirstLetter(item)
                }}</span>
              </v-tooltip>
              <v-tooltip
                right
                v-else-if="item != undefined && item.toLowerCase().indexOf('cancelada') != -1"
              >
                <template v-slot:activator="{ on }">
                  <v-chip
                    small
                    v-on="on"
                    color="primary"
                    text-color="white"
                    @click="handleInfo(props.item,'STATUSERPDOIS')"
                    >
                        <span style="cursor: pointer;">{{ capitalizeFirstLetter(item) }}</span>
                  </v-chip>
                </template> 
                <span>{{
                  props.item.log_statusErpDois ? props.item.log_statusErpDois : capitalizeFirstLetter(item)
                }}</span>
              </v-tooltip>
              <v-chip
                v-else-if="
                  item &&
                    item != undefined &&
                    item.toLowerCase().indexOf('validada') != -1
                "
                small
                color="orange"
                text-color="white"
                >{{ capitalizeFirstLetter(item) }}</v-chip
              >
              <v-chip
                v-else-if="
                  item &&
                    item != undefined &&
                    item.toLowerCase().indexOf('pre') != -1 &&
                    item.toLowerCase().indexOf('nota') != -1
                "
                small
                color="yellow lighten-2"
                text-color="black"
                >{{ capitalizeFirstLetter(item) }}</v-chip
              >
              <v-chip
                v-else-if="
                  item &&
                    item != undefined &&
                    item.toLowerCase().indexOf('nota') != -1 &&
                    item.toLowerCase().indexOf('classificada') != -1
                "
                small
                color="green"
                text-color="white"
                >{{ capitalizeFirstLetter(item) }}</v-chip
              >
              <v-tooltip
                right
                v-else-if="item != undefined && item.toLowerCase().indexOf('falha') != -1"
              >
                <template v-slot:activator="{ on }">
                  <v-chip
                    small
                    v-on="on"
                    color="red"
                    text-color="white"
                    @click="handleFailure(props.item,'STATUSERPDOIS')"
                    >
                        <span style="cursor: pointer;">{{item}}</span>
                  </v-chip>
                </template> 
                <span>{{
                  props.item.log_statusErpDois ? props.item.log_statusErpDois : 'Falha'
                }}</span>
              </v-tooltip>
              <v-chip
                v-else-if="item != undefined && item != ''"
                small
                color="grey"
                text-color="white"
                >{{ capitalizeFirstLetter(item) }}</v-chip
              >
            </span>
            <span v-else-if="index === 'posFechamento'">

              <v-tooltip
                right
                v-if="item != undefined"
              >
                <template v-slot:activator="{ on }">
                  <v-chip
                    small
                    v-on="on"
                    color="red"
                    text-color="white"
                    >
                        <span style="cursor: pointer;">{{ capitalizeFirstLetter(item) }}</span>
                  </v-chip>
                </template>
                <span>Nota emitida após o fechamento entre as datas 26 - 31</span>
              </v-tooltip>
              <v-tooltip
                right
                v-else
              >
                <template v-slot:activator="{ on }">
                  <v-chip
                    small
                    v-on="on"
                    color="green"
                    text-color="white"
                    >
                        <span style="cursor: pointer;">Não</span>
                  </v-chip>
                </template> 
              </v-tooltip>
            </span>
            <span v-else-if="index.toLowerCase().indexOf('pagtoiptu') != -1">
              <v-chip
                v-if="
                  item &&
                    item != undefined &&
                    item.toLowerCase().indexOf('avista') != -1
                "
                small
                color="green"
                text-color="white"
                >A Vista</v-chip
              >
              <v-chip
                v-if="
                  item &&
                    item != undefined &&
                    item.toLowerCase().indexOf('parcelado') != -1
                "
                small
                color="blue"
                text-color="white"
                >Parcelado</v-chip
              >
              <v-chip
                v-if="
                  item &&
                    item != undefined &&
                    item.toLowerCase().indexOf('ambos') != -1
                "
                small
                color="orange"
                text-color="white"
                >Ambos</v-chip
              >
            </span>

            <span v-else-if="index == 'statusDES'">
              <v-chip
                v-if="
                  item &&
                    item != undefined &&
                    item.toLowerCase().indexOf('pendente') != -1
                "
                small
                color="grey darken-3"
                text-color="white"
                >Pendente</v-chip
              >
              <v-chip
                v-if="
                  item &&
                    item != undefined &&
                    item.toLowerCase().indexOf('validado') != -1
                "
                small
                color="blue"
                text-color="white"
                >Validado</v-chip
              >
              <v-chip
                v-if="
                  item &&
                    item != undefined &&
                    item.toLowerCase().indexOf('inconsistente') != -1
                "
                small
                color="orange"
                text-color="white"
                >Inconsistente</v-chip
              >
            </span>

            <span v-else-if="index.toLowerCase().indexOf('statusin') != -1">
              <v-chip
                v-if="
                  (item != undefined &&
                    item &&
                    props.item.preCadastro != undefined &&
                    props.item.preCadastro.length == 0) ||
                    (props.item.preCadastro == undefined && props.item.statusIn)
                "
                small
                color="green"
                text-color="white"
                >Ativo</v-chip
              >
              <v-chip
                v-else-if="
                  item != undefined &&
                    item &&
                    props.item.preCadastro != undefined &&
                    props.item.preCadastro.length > 0
                "
                small
                color="yellow darken-2"
                text-color="white"
                >Pendente</v-chip
              >
              <v-chip
                v-else-if="item != undefined && !item"
                small
                color="red"
                text-color="white"
                >Inativo</v-chip
              >
            </span>
            <span v-else-if="index.toLowerCase().indexOf('plano') != -1">
              <v-chip
                v-if="item == 'micro'"
                small
                color="cyan darken-2"
                text-color="white"
                >{{ getTextPlano(item) }}</v-chip
              >
              <v-chip
                v-else-if="item == 'gestao'"
                small
                color="indigo darken-2"
                text-color="white"
                >{{ getTextPlano(item) }}</v-chip
              >
              <v-chip
                v-else-if="item == 'performance'"
                small
                color="orange darken-2"
                text-color="white"
                >{{ getTextPlano(item) }}</v-chip
              >
              <v-chip
                v-else-if="item == 'super'"
                small
                color="red"
                text-color="white"
                >{{ getTextPlano(item) }}</v-chip
              >
              <v-chip
                v-else
                small
                color="blue-grey darken-4"
                text-color="white"
                >{{ getTextPlano(item) }}</v-chip
              >
            </span>
            <span v-else-if="index.toLowerCase().indexOf('bloqueada') != -1">
              <v-chip v-if="item" small color="red" text-color="white"
                >Sim</v-chip
              >
              <v-chip v-else small color="green" text-color="white">Não</v-chip>
            </span>
            <span v-else-if="index === 'dataServico'">{{
              item != undefined && item instanceof Date && !isNaN(item)
                ? item.toLocaleDateString("pt-BR")
                : item
            }}</span>
            <span v-else-if="index === 'dtEmissaoNfe'">{{
              item != undefined && item instanceof Date && !isNaN(item)
                ? item.toLocaleDateString("pt-BR")
                : item
            }}</span>
            <span
              v-else-if="index.toLowerCase().indexOf('rela_totalemp') != -1"
            >
              <colunaListEmprConta
                :component="component"
                :item="props.item"
              ></colunaListEmprConta>
            </span>
            <span v-else-if="index.toLowerCase().indexOf('rela_plano') != -1">{{
              getTextPlano(item)
            }}</span>
            <span v-else-if="index.toLowerCase().indexOf('vinculo') != -1">
              <colunaVinculo
                :component="component"
                :nota="props"
              ></colunaVinculo>
            </span>
            <span v-else-if="index.toLowerCase().indexOf('cnpj') != -1">{{
              item != undefined
                ? item.length > 11
                  ? item.replace(
                      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                      "$1.$2.$3/$4-$5"
                    )
                  : item.replace(/^(\d{3})(\d{3})(\d{3})(\d)/, "$1.$2.$3-$4")
                : ""
            }}</span>
            <span
              v-else-if="index.toLowerCase().indexOf('rela_dtlastlogin') != -1"
              >{{
                item != undefined && item instanceof Date && !isNaN(item)
                  ? `${item.toLocaleDateString("pt-BR", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    })} ${item.toLocaleTimeString()}`
                  : item
              }}</span
            >
            <span
              v-else-if="
                index.toLowerCase().indexOf('dt') != -1 ||
                  index.toLowerCase().indexOf('emissao') != -1
              "
              >{{
                item != undefined && item instanceof Date && !isNaN(item)
                  ? item.toLocaleDateString("pt-BR", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    })
                  : item
              }}</span
            >
            <span
              v-else-if="index.toLowerCase().indexOf('certificado') != -1"
              :style="
                item == undefined || item.validade.venc ? 'color: red' : ''
              "
              >{{
                item != undefined
                  ? item.validade.data.toLocaleDateString("pt-BR", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    })
                  : "Pendente"
              }}</span
            >
            <span
              v-else-if="index.toLowerCase().indexOf('validade') != -1"
              :style="props.item.bvenc ? 'color: red' : ''"
              >{{ item != undefined ? item : "" }}</span
            >
            <span
              v-else-if="index.toLowerCase().indexOf('colaboradores') != -1"
              >{{ item == undefined ? 0 : item.length }}</span
            >
            <span
              :id="'uf_' + item"
              v-else-if="
                index.toLowerCase().indexOf('uf') != -1 &&
                  component.name == 'empresa'
              "
              >{{ item != undefined ? getUfById(item) : "" }}</span
            >
            <span v-else-if="index.toLowerCase().indexOf('duplicata') != -1">
              <colunaVencimento
                :component="component"
                :item="item"
                :empresa="empresa"
              ></colunaVencimento>
            </span>
            <span v-else-if="index.toLowerCase().indexOf('produtos') != -1">
              <colunaProdutos
                :component="component"
                :item="item"
                :empresa="empresa"
              ></colunaProdutos>
            </span>
            <span v-else-if="index.toLowerCase() == 'produto'">{{
              item == undefined ? 0 : item.length
            }}</span>
            <span
              v-else-if="
                index.toLowerCase().indexOf('valor') != -1 ||
                  index.toLowerCase().indexOf('vlr') != -1 ||
                  index.toLowerCase().indexOf('pis') != -1 ||
                  index.toLowerCase().indexOf('cofins') != -1 ||
                  index.toLowerCase().indexOf('csll') != -1 ||
                  index.toLowerCase().indexOf('inss') != -1 ||
                  index.toLowerCase().indexOf('ir') != -1 ||
                  index.toLowerCase().indexOf('acrescimos') != -1||
                  index.toLowerCase().indexOf('deducoes') != -1||
                  index.toLowerCase().indexOf('desconto') != -1||
                  index.toLowerCase().indexOf('multa') != -1
              "
              >{{
                item != undefined
                  ? item.toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })
                  : ""
              }}</span
            >
            <span v-else-if="index.toLowerCase().indexOf('prodrastro') != -1">
              <colunaLote :component="component" :item="item"></colunaLote>
            </span>
            <v-edit-dialog
              v-else-if="index.indexOf('faturamento') != -1"
              :id="index"
              class="text-xs-center"
              :return-value.sync="props.item.faturamento"
              large
              lazy
              :persistent-hint="false"
              @save="save(props.item, index)"
              @cancel="cancel"
              cancel-text="Cancelar"
              save-text="Salvar"
              :transition="'slide-y-transition'"
            >
              <v-chip
                v-if="item != undefined && item.toLowerCase() == 'sim'"
                small
                color="green"
                text-color="white"
                >{{ item }}</v-chip
              >
              <v-chip
                v-else-if="item != undefined && item.toLowerCase() == 'não'"
                small
                color="red"
                text-color="white"
                >{{ item }}</v-chip
              >
              <div slot="input" class="mt-3 title">Atualizar informação</div>
              <v-select
                slot="input"
                v-model="props.item.faturamento"
                :persistent-hint="false"
                :items="['Sim', 'Não']"
                color="teal"
                :prepend-icon="item.prepIcon"
                no-data-text="Erro na consulta de dados"
                return-object
                :multiple="false"
                single-line
                autofocus
              ></v-select>
            </v-edit-dialog>
            <v-edit-dialog
              v-else-if="index.indexOf('custom_') != -1"
              :id="index"
              class="text-xs-center"
              :return-value.sync="item.value"
              large
              lazy
              persistent
              @save="save(props.item, index)"
              @cancel="cancel"
              cancel-text="Cancelar"
              save-text="Salvar"
            >
              <div>{{ item.value }}</div>
              <div slot="input" class="mt-3 title">Atualizar informação</div>
              <v-text-field
                slot="input"
                v-model="item.value"
                label="Editar"
                single-line
                counter
                autofocus
                clearable
              ></v-text-field>
            </v-edit-dialog>
            <span v-else>{{ item }}</span>
          </td>
        </tr>
      </template>
      <template slot="no-data">
        <v-alert :value="true" color="indigo darken-4" icon="info" outline>
          <article v-if="table.loading">
            Motor Fiscal está buscando as informações
          </article>
          <article v-if="!table.loading">
            <strong style="text-transform: uppercase;">{{
              empresa != undefined ? empresa.razao : ""
            }}</strong>
            Não possui
            <strong>{{ component.text }}</strong>
            disponível para consulta
            <article
              style="display: inline-block"
              v-if="this.component.enable.rangeDate"
            >
              <span
                v-if="
                  this.component.enable.filtrar && this.table.urlFiltros != ''
                "
              >
                com estes
                <b style="text-transform: uppercase;">filtros</b>
              </span>
              <span v-else>
                <b>{{ setTextRange }}</b>
              </span>
            </article>
            .
          </article>
        </v-alert>
      </template>

      <template slot="pageText" slot-scope="props">
        <v-tooltip
          v-if="
            component.name != 'rela_usuario' &&
              component.name != 'conta' &&
              component.name != 'fornecedores' &&
              component.name != 'certificado' &&
              component.name != 'usuario' &&
              component.name != 'clientes' &&
              component.name != 'empresa' &&
              component.name != 'produtos' &&
              component.name != 'Iptu'
          "
          bottom
        >
          <div
            slot="activator"
            class="d-block"
            style="color: black; font-size: 18px; "
          >
            <strong style="color: #25476a;">Total</strong>:
            <span>{{
              table.valor_total_notas.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })
            }}</span>
          </div>
          <span
            v-if="
              component.name != 'fornecedores' && component.name != 'clientes'
            "
            >Valor total das {{ component.abrev }} exibidas</span
          >
        </v-tooltip>
        <v-tooltip v-else-if="component.name == 'conta'" bottom>
          <div
            slot="activator"
            class="d-block"
            style="color: black; font-size: 18px; "
          >
            <small>
              <strong style="color: #25476a;">Total</strong>:
              <!-- <div class="conta_totalizar">
                <strong>NF-e:</strong>
                {{ table.valor_total_conta_nfe }}
              </div>
              <div class="conta_totalizar">
                <strong>CT-e:</strong>
                {{ table.valor_total_conta_cte }}
              </div>
              <div class="conta_totalizar">
                <strong>NFS-e:</strong>
                {{ table.valor_total_conta_nfse }}
              </div> -->
              <div class="conta_totalizar">
                <strong>Empresa:</strong>
                {{ table.valor_total_conta_empr }}
              </div>
              <div class="conta_totalizar">
                <strong>Colaborador:</strong>
                {{ table.valor_total_conta_colab }}
              </div>
            </small>
          </div>
          <span
            v-if="
              component.name != 'fornecedores' && component.name != 'clientes'
            "
            >Valor total das {{ component.abrev }} exibidas</span
          >
        </v-tooltip>
        {{ table.getPosNFeExibidas(props.pageStart, props.pageStop) }}
        <strong>
          Exibindo {{ props.pageStart }} - {{ props.pageStop }} do total de
          {{ table.qnt_total_notas }}
          <span>{{
            table.qnt_total_notas > 1 ? component.textPlural : component.text
          }}</span> </strong
        >.
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning"
        >Sua pesquisa por "{{ search }}" não tem resultados.</v-alert
      >
    </v-data-table>
    <template>
      <div class="text-xs-center pt-2 btn_pages" id="pagination_button">
        <v-pagination
          v-model="pagination.page"
          :total-visible="6"
          color="teal"
          :length="table.qnt_total_paginas"
          @click.native="selected = table.selecionarTodosItens('clear')"
        ></v-pagination>
      </div>
    </template>

    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn flat @click="snack = false">Fechar</v-btn>
    </v-snackbar>

    <SnackComp :table="this.table"></SnackComp>
  </v-card>
</template>

<script>
import Nfe from "@/domain/notas/nfe/Nfe.js";
import NfeService from "@/domain/notas/nfe/NfeService";
import CteService from "@/domain/notas/cte/CteService";
import NfseService from "@/domain/notas/nfse/NfseService";
import ClientesService from "@/domain/clientes/ClientesService";
import EmpresaService from "@/domain/conta/empresa/EmpresaService";
import CertificadoService from "@/domain/conta/empresa/certificado/CertificadoService";
import ProdutosService from "@/domain/produtos/ProdutosService";
import FornecedoresService from "@/domain/fornecedores/FornecedoresService";
import UsuariosService from "@/domain/conta/usuario/UsuarioService.js";
import ContaService from "@/domain/conta/ContaService.js";
import IptuService from "@/domain/automacaoFiscal/iptu/IptuService";

import Table from "@/domain/dataTable/Table";
import TableNfe from "@/domain/dataTable/TableNfe";
import TableNfseEmitida from "@/domain/dataTable/TableNfseEmitida";
import TableNfse from "@/domain/dataTable/TableNfse";
import TableCte from "@/domain/dataTable/TableCte";
import TableClientes from "@/domain/dataTable/TableClientes";
import TableFornecedores from "@/domain/dataTable/TableFornecedores";
import TableProdutos from "@/domain/dataTable/TableProdutos";
import TableProdutosEmitida from "@/domain/dataTable/TableProdutosEmitida";
import TableCertificados from "@/domain/dataTable/TableCertificados";
import TableEmpresas from "@/domain/dataTable/TableEmpresas";
import TableUsuarios from "@/domain/dataTable/TableUsuarios";
import TableContas from "@/domain/dataTable/TableContas.js";
import TableRelaUsuarios from "@/domain/dataTable/TableRelaUsuarios";
import TableIptu from "@/domain/dataTable/TableIptu";

import colunaListEmprConta from "@/components/dataTable/commonTable/coluna_listEmprConta/Coluna_listEmprConta.vue";
import colunaLogins from "@/components/dataTable/commonTable/coluna_logins/Coluna_Logins.vue";
import columnActions from "./coluna_actions/ColumnActions.vue";
import actionsHeader from "./actionsHeader/ActionsHeader";
import btnDias from "./actionsHeader/btnDias/BtnDias.vue";
import btnFiltrar from "./actionsHeader/btnFiltrar/BtnFiltrar.vue";
import panelFiltro from "./actionsHeader/btnFiltrar/panelFiltro/PanelFiltro.vue";
import Coluna_Vinculo from "./coluna_vinculo/Coluna_Vinculo.vue";
import ColunaManifestoBtn from "./coluna_manifesto_btn/ColunaManifestoBtn.vue";
import Coluna_vencimento from "./coluna_vencimento/Coluna_vencimento.vue";
import Coluna_produtos from "./coluna_produtos/Coluna_produtos.vue"
import Coluna_lote from "./coluna_lote/Coluna_lote.vue";
import Coluna_simples from "./coluna_simples/Coluna_simples.vue";
import Coluna_tributacao from "./coluna_tributacao/Coluna_tributacao.vue";
import Coluna_lei from "./coluna_lei116/Coluna_lei.vue";
import Coluna_infAd from "./coluna_infAd/Coluna_infAd.vue";
import btnMoverTable from "./actionsHeader/btnMoverTable/BtnMoverTable.vue";
import CommonService from "@/domain/dataTable/commonService/CommonService.js";
import { arrayPlanos } from "@/domain/planos/planos.js";
import SnackComp from "./snackBar/SnackBar.vue";
import { setTimeout } from "timers";
export default {
  components: {
    columnActions: columnActions,
    actionsHeader: actionsHeader,
    colunaVinculo: Coluna_Vinculo,
    colunaVencimento: Coluna_vencimento,
    colunaLogins: colunaLogins,
    colunaLote: Coluna_lote,
    colunaSimples: Coluna_simples,
    colunatributacao: Coluna_tributacao,
    colunalei: Coluna_lei,
    colunaInfAd: Coluna_infAd,
    btnDias: btnDias,
    btnFiltrar: btnFiltrar,
    panelFiltro: panelFiltro,
    btnMoverTable: btnMoverTable,
    SnackComp: SnackComp,
    colunaListEmprConta: colunaListEmprConta,
    colunaManifestoBtn: ColunaManifestoBtn,
    colunaProdutos: Coluna_produtos, 
   },
  props: [
    "conta",
    "empresa",
    "alert",
    "component",
    "logConsulta",
    "attTable",
    "arrayItems",
    "logQtd",
    "IBGE",
  ],
  data: () => ({
    failureDialog: false,
    infoDialog: false,
    errors: "",
    infos:"",
    nextPage: "",
    table: new TableNfe(),
    filtro: false,
    headersAtualizado: false,
    filtroForSearch: { text: "Tudo", value: "tudo" },
    snack: false,
    snackColor: "",
    snackText: "",
    aux_pages: 1,
    search: "",
    dialog: false,
    range: "mesAtual",
    remove_headers: false,
    nomeUF: "",
    pagination: {},
    selected: [],
    arrayUF: [],
  }),

  updated: function() {
    this.$nextTick(function() {
      //organiza o texto do botão remover
      var btn = document.querySelector("#btn_clsFiltros");
      if (btn != undefined) {
        btn.firstElementChild.style.width = "unset";
      }
      this.setValorTotal;
      this.setTotalizaValoresConta;

      if (!this.headersAtualizado) {
        this.getEmpresa;
      }
    });
  },
  created: function() {},
  mounted: function() {
    this.$nextTick(function() {
      this.handleService();
    });
  },
  watch: {
    updateTable: async function(newV, oldV) {
      if (newV) {
        this.handleService();
        // this.service = new NfseService(this.$http);
        // this.getItems("getNfseEmitidas", 2);
      }
    },
    search: function() {
      this.table.selected = [];
      this.selected = [];
    },
    attTable: async function(newV, oldV) {
      if (newV) {
        this.table.resetTable(this.empresa, this.component);
        this.table.pagination.page = 1;
        await this.getDadosApi();
        this.$emit("emitAttTable", false);
      }
    },
    empresa: async function(newVal, oldVal) {
      if (newVal._id != oldVal._id) {
        this.filtro = false;
        this.range = "mesAtual";
        this.table.resetTable(this.empresa, this.component);
        this.table.pagination.page = 1;
        this.getDadosApi();
      }
    },
    "table.sendAtt": async function(newV, oldV) {
      if (newV) {
        // this.table.resetTable();
        this.table.pagination.page = 1;
        console.log("table send");
        await this.getDadosApi();
        this.table.sendAtt = false;
      }
    },
    "pagination.rowsPerPage": function(newVal, oldVal) {
      if (newVal) {
        this.loading = true;
        this.table.pagination = this.pagination;
        // this.table.pagination.rowsPerPage = newVal;
        if (this.table.arrayNotas.length > 0) {
          if (this.table.pagination.rowsPerPage == "Todas") {
            this.table.pagination.rowsPerPage = this.table.array_todas_notas.length;
          }
          this.table.tradeNotaArray(
            this.table.pagination.rowsPerPage,
            this.table.arrayNotas.length
          );

          this.table.setPages(
            this.table.array_todas_notas.length,
            this.table.pagination.rowsPerPage
          );

          if (newVal > oldVal) {
            //necessario pois sempre que muda a quantidade de itens exibidos na tabela os headers voltam a aparecer
            this.remove_headers = true;
            this.removeHeaders;
          }
        }
        this.loading = false;
      }
    },
    "pagination.page": function(newVal, oldVal) {
      this.table.pagina_atual = newVal;
      if (
        this.table.pagina_atual != 1 &&
        this.table.arrayNotas.length < this.table.qnt_total_notas
      ) {
        var qntdade_notas =
          this.table.pagination.rowsPerPage * this.table.pagina_atual;
        this.table.tradeNotaArray(qntdade_notas, this.table.arrayNotas.length);
      }
    },
    range: function() {
      this.resetState();
      this.table.selected = [];
      this.selected = [];
      // this.table.qnt_total_paginas = 1;

      let component = this.component.name;

      this.table.rangeButtons.forEach(function(item) {
        let aux_btn = document.querySelector(`.btn_${item.value}_${component}`);
        aux_btn.classList.add("v-btn--outline");
        aux_btn.classList.add("teal--text");
        if (item && item.value == "tudo") {
          let iconFiltrar = document.querySelector(
            `.btn_${item.value}_${component} .iconFiltrarRangedButtons`
          );
          if (iconFiltrar) {
            iconFiltrar.classList.remove("white--text");
            iconFiltrar.classList.add("teal--text");
          }
        }
        aux_btn.classList.remove("teal");
        aux_btn.classList.remove("white--text");
      });

      if (this.range == "tudo") {
        let iconFiltrar = document.querySelector(
          `.btn_${this.range}_${component} .iconFiltrarRangedButtons`
        );
        if (iconFiltrar) {
          iconFiltrar.classList.remove("teal--text");
          iconFiltrar.classList.add("white--text");
        }
      }

      let btn = document.querySelector(`.btn_${this.range}_${component}`);
      btn.classList.remove("v-btn--outline");
      btn.classList.remove("bg_white");
      btn.classList.remove("teal--text");
      btn.classList.add("teal");
      btn.classList.add("white--text");

      if (this.range == "tudo" && !this.table.urlFiltros) {
        return;
      } else if (this.range != "tudo" && this.table.urlFiltros) {
        this.table.resetFiltro();
        this.table.filtros.fechar = true;
        this.getFiltro();
      }

      this.getDadosApi();
    },
  },
  computed: {
    updateTable() {
      return this.$store.getters.updateTable;
    },
    tableNfeRecebidas() {
      return this.$store.getters.tableNfeRecebidas;
    },
    tableNfeEmitidas() {
      return this.$store.getters.tableNfeEmitidas;
    },
    tableNfeTransportados() {
      return this.$store.getters.tableNfeTransportados;
    },
    
    
    tableCteTodos() {
      return this.$store.getters.tableCteTodos;
    },
    tableCteTomados() {
      return this.$store.getters.tableCteTomados;
    },
    tableNfseRecebidas() {
      return this.$store.getters.tableNfseRecebidas;
    },
    tableNfseEmitidas() {
      return this.$store.getters.tableNfseEmitidas;
    },
    tableClientes() {
      return this.$store.getters.tableClientes;
    },
    tableFornecedores() {
      return this.$store.getters.tableFornecedores;
    },
    tableProdutos() {
      return this.$store.getters.tableProdutos;
    },
    tableProdutosEmitidas() {
      return this.$store.getters.tableProdutosEmitidas;
    },
    tableEmpresas() {
      return this.$store.getters.tableEmpresas;
    },
    tableCertificados() {
      return this.$store.getters.tableCertificados;
    },
    getEmpresa() {
      this.headersAtualizado = true;
    },
    setAttrFirstLine: function() {
      //ao gerar a tabela o  não cria um atributo na 1º linha da tabela, impedindo assim o funcionamento correto das informações
      var table = document.querySelector(".table_" + this.component.name);
      var tableAttr = table.getAttributeNames();
      var pos = null;

      tableAttr.forEach(function(item, i) {
        item.indexOf("data") != -1 ? (pos = i) : "";
      });
      if (pos != null) {
        var getAttr = tableAttr[pos];
        var frstLineTable = document.querySelector(
          ".table_" + this.component.name + " tbody"
        ).firstElementChild;
        frstLineTable.setAttribute(getAttr, "");
        frstLineTable.firstElementChild.setAttribute(getAttr, "");
      }
    },
    setValorTotal: function() {
      var vlrTotal = 0;
      let propSomar = "valor";
      if (this.component.name == "NFSE") {
        propSomar = "vlrServico";
      }
      if (this.table.dadosFiltrados && this.table.arraySearch.length > 0) {
        for (
          var i = this.table.posExbPrimNota;
          i < this.table.posExbUltmaNota;
          i++
        ) {
          vlrTotal += this.table.arraySearch[i][propSomar];
        }
      } else if (this.table.arrayNotas.length > 0) {
        for (
          var i = this.table.posExbPrimNota;
          i < this.table.posExbUltmaNota;
          i++
        ) {
          vlrTotal += this.table.arrayNotas[i][propSomar];
        }
      }
      this.table.valor_total_notas = vlrTotal;
    },
    setTotalizaValoresConta: function() {
      if (this.component.name == "conta") {
        var total_empr = 0;
        // var total_nfe = 0;
        // var total_nfse = 0;
        // var total_cte = 0;
        var total_colabs = 0;
        let propEmpr = "rela_totalEmp";
        // let propNfe = "rela_totalNfe";
        // let propNfse = "rela_totalNfse";
        // let propCte = "rela_totalCte";
        let propColab = "rela_totalColab";
        if (this.table.dadosFiltrados && this.table.arraySearch.length > 0) {
          for (
            var i = this.table.posExbPrimNota;
            i < this.table.posExbUltmaNota;
            i++
          ) {
            total_empr += this.table.arraySearch[i][propEmpr];
            // total_nfe += this.table.arraySearch[i][propNfe];
            // total_nfse += this.table.arraySearch[i][propNfse];
            // total_cte += this.table.arraySearch[i][propCte];
            total_colabs += this.table.arraySearch[i][propColab];
          }
        } else if (this.table.arrayNotas.length > 0) {
          for (
            var i = this.table.posExbPrimNota;
            i < this.table.posExbUltmaNota;
            i++
          ) {
            total_empr += this.table.arrayNotas[i][propEmpr];
            // total_nfe += this.table.arrayNotas[i][propNfe];
            // total_nfse += this.table.arrayNotas[i][propNfse];
            // total_cte += this.table.arrayNotas[i][propCte];
            total_colabs += this.table.arrayNotas[i][propColab];
          }
        }
        this.table.valor_total_conta_empr = total_empr;
        // this.table.valor_total_conta_nfe = total_nfe;
        // this.table.valor_total_conta_nfse = total_nfse;
        // this.table.valor_total_conta_cte = total_cte;
        this.table.valor_total_conta_colab = total_colabs;
      }
    },
    removeHeaders: function() {
      if (
        this.table.posExbUltmaNota - this.table.posExbPrimNota !=
        this.table.pagination.rowsPerPage
      ) {
        this.remove_headers = true;
      }
      if (
        this.remove_headers &&
        (this.table.posExbUltmaNota - this.table.posExbPrimNota ==
          this.table.pagination.rowsPerPage ||
          this.table.pagination.rowsPerPage >= this.table.qnt_total_notas)
      ) {
        this.table.headers.forEach(function(item) {
          if (item.value != "acoes") {
            if (!item.show) {
              var id = "#" + item.value;
              document
                .querySelectorAll(id)
                .forEach((item) => (item.style.display = "none"));
            }
          }
        });
        this.remove_headers = false;
      }
    },
    setTextRange() {
      let range = this.range;
      this.table.rangeButtons.forEach((i) => {
        if (i.value == range) {
          range = i.noDataText;
        }
      });
      return range;
    },
  },
  methods: {
    handleInfo(props,tipo) {
      if (props.log_statusErp && tipo === 'STATUSERP'){
        this.infos = props.log_statusErp;
        this.infoDialog = true;
      }else if (props.log_statusErpDois && tipo === 'STATUSERPDOIS'){
        this.infos = props.log_statusErpDois;
        this.infoDialog = true;
      }else {
        return;
      }
    },
    handleFailure(props,tipo) {
    if (props.erroEmissao && tipo == 'EMISSAO') {
      this.errors = props.erroEmissao;
      this.failureDialog = true;
      }else if (props.log_escrituracao && tipo === 'ESCRITURACAO'){
        this.errors = props.log_escrituracao;
        this.failureDialog = true;
      }else if (props.log_integracao && tipo === 'INTEGRACAO'){
        this.errors = props.log_integracao;
        this.failureDialog = true;
      }else if (props.log_ocr && tipo === 'OCR'){
        this.errors = props.log_ocr;
        this.failureDialog = true;
      }else if (props.logErroFtpXml && tipo === 'XML'){
        this.errors = props.logErroFtpXml;
        this.failureDialog = true;
      }else if (props.logErroFtpPdf && tipo === 'PDF'){
        this.errors = props.logErroFtpPdf;
        this.failureDialog = true;
      }else if (props.log_statusErp && tipo === 'STATUSERP'){
        this.errors = props.log_statusErp;
        this.failureDialog = true;
      }else if (props.log_statusErpDois && tipo === 'STATUSERPDOIS'){
        this.errors = props.log_statusErpDois;
        this.failureDialog = true;
      }else {
        return;
      }
    },
    
    handleService() {
      if (this.component.name.indexOf("NFe") != -1) {
        this.table = new TableNfe(this.component);
      } else if (this.component.name.indexOf("CTE") != -1) {
        this.table = new TableCte();
      } else if (this.component.name == "NFSE") {
        if (this.component.tipo == "recebida") {
          this.table = new TableNfse();
        } else if (this.component.tipo == "emitida") {
          this.table = new TableNfseEmitida();
        }
      } else if (this.component.name == "fornecedores") {
        this.table = new TableFornecedores();
      } else if (this.component.name == "clientes") {
        this.table = new TableClientes();
      } else if (this.component.name == "produtos") {
        if (this.component.tipo == "recebida") {
          this.table = new TableProdutos();
        } else if (this.component.tipo == "emitida") {
          this.table = new TableProdutosEmitida();
        }
      } else if (this.component.name == "empresa") {
        this.table = new TableEmpresas();
      } else if (this.component.name == "Iptu") {
        this.table = new TableIptu();
      } else if (this.component.name == "certificado") {
        this.table = new TableCertificados();
      } else if (this.component.name == "usuario") {
        this.table = new TableUsuarios();
      } else if (this.component.name == "conta") {
        this.table = new TableContas();
      } else if (this.component.name == "rela_usuario") {
        this.table = new TableRelaUsuarios();
      } else {
        throw new Error(`Tabela: '${component.name}' não codificada`);
      }
      this.getUFs_IBGE;
      this.setAttrFirstLine;
      this.table.pagination = this.pagination;
      if (
        (this.empresa == undefined && this.table.arrayNotas == 0) ||
        (this.empresa.razao && this.table.arrayNotas == 0)
      ) {
        this.table.resetTable(this.empresa, this.component);
        this.getDadosApi();
      }
      this.$store.commit("addUpdateTable", false);
    },
    resetState() {
      this.$store.commit("ressetAllStates");
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    ordenaCustomColumns(column) {
      if (
        column.indexOf("custom_") != -1 &&
        this.pagination.descending == false
      ) {
        //ordem crescente
        this.table.arrayNotas.sort(function(a, b) {
          if (a[column].value != "" && b[column].value == "") {
            return -1;
          }
          if (a[column].value == "" && b[column].value != "") {
            return 1;
          }
          return a[column].value > b[column].value
            ? 1
            : a[column].value < b[column].value
            ? -1
            : 0;
        });
      } else if (
        column.indexOf("custom_") != -1 &&
        this.pagination.descending == true
      ) {
        //order decrescente
        this.table.arrayNotas.sort(function(a, b) {
          if (a[column].value != "" && b[column].value == "") {
            return -1;
          }
          if (a[column].value == "" && b[column].value != "") {
            return 1;
          }
          return a[column].value < b[column].value
            ? 1
            : a[column].value > b[column].value
            ? -1
            : 0;
        });
      }
    },
    ordenaColumnsVinculo(column) {
      if (column == "vinculo") {
        if (this.pagination.descending == true) {
          this.table.arrayNotas.sort((a, b) =>
            a.cte.length < b.cte.length
              ? 1
              : a.cte.length > b.cte.length
              ? -1
              : a.xmlCce.length < b.xmlCce.length
              ? 1
              : a.xmlCce.length > b.xmlCce.length
              ? -1
              : 0
          );
        } else {
          this.table.arrayNotas.sort((a, b) =>
            a.cte.length < b.cte.length
              ? -1
              : a.cte.length > b.cte.length
              ? 1
              : a.xmlCce.length < b.xmlCce.length
              ? -1
              : a.xmlCce.length > b.xmlCce.length
              ? 1
              : 0
          );
        }
      }
    },
    getUfById(id) {
      this.arrayUF = this.IBGE.estados;
      let uf = "";
      this.arrayUF.forEach((item) => {
        if (item.id == id) {
          uf = item;
        }
      });
      return uf.nome;
    },
    rmvThisFilter(item, txt, $event) {
      if ($event.target.nodeName != "I") {
        return;
      }

      if (txt != undefined) {
        let pos = null;
        item.valor.forEach(function(v, index) {
          if (v == txt) {
            pos = index;
          }
        });
        if (pos != null) {
          item.valor.splice(pos, 1);
        }
      } else {
        item.valor = null;
      }
      this.getFiltro();
    },
    getDataBusca: function($event) {
      if (
        $event === "semana" ||
        $event === "mesAtual" ||
        $event === "mesAnterior"
      ) {
        this.filtro = false;
      }
      this.range = $event;
      this.$emit("getNewEmp", this.empresa);
    },
    attTableEmp(value) {
      if (this.component.name == "certificado") {
        this.$emit("emitAttTable", value);
      } else {
        this.$emit("attTableEmp", value);
      }
    },
    changeSort(column) {
      if (this.table.array_todas_notas.length > 0) {
        this.table.tradeNotaArray(
          //pega todas as notas para ordenar no customSort.
          this.table.qnt_total_notas,
          this.table.arrayNotas.length
        );
        if (this.pagination.sortBy == column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
        //ordenando custom coluns
        this.ordenaCustomColumns(column);
        this.ordenaColumnsVinculo(column);
      }
    },
    getFiltro() {
      this.resetState();
      this.filtro = !this.table.filtros.fechar;
      let url = "";
      // console.log('oioioioioii',this.table);
      this.table.filtros.items.forEach(function(item) {
        if (item.item_id == "cce") {
          if (item.valor == "Não") {
            url += `&_cce=${false}`;
          }
          if (item.valor == "Sim") {
            url += `&_cce=${true}`;
          }
        }
        if (item.item_id == "tipoVencimento") {
          if (item.valor == "Parcela única") {
            url += `&_tipoVencimento=0`;
          }
          if (item.valor == "Parcelado") {
            url += `&_tipoVencimento=1`;
          }
          if (item.valor == "Não informado") {
            url += `&_tipoVencimento=2`;
          }
        }

        if (item.item_id == "protocolada") {
          if (item.valor != null) {
            url += `&_protocolada=${item.valor}`;
          }
        }

        if (item.item_id == "status") {
          if (item.valor != null) {
            if (item.valor.length > 0) {
              url += "&_status=";
            }
            for (let i = 0; i < item.valor.length; i++) {
              if (i > 0) {
                url += ",";
              }
              url += item.valor[i];
            }
          }
        }

        if (item.item_id == 'statusDes') {
          if(item.valor != null) {
            if (item.valor.length > 0) {
              url += "&_statusDes="
            }
            for (let i = 0; i < item.valor.length; i++) {
              if (i > 0) {
                url += ",";
              }
              url += item.valor[i];
          }
        }
      }

        if (item.item_id == "manifestacao") {
          if (item.valor != null) {
            if (item.valor.length > 0) {
              url += "&_manifestacao=";
            }
            for (let i = 0; i < item.valor.length; i++) {
              if (i > 0) {
                url += ",";
              }
              url += item.valor[i];
            }
          }
        }
        if (item.item_id == "emissaoIni") {
          if (item.valor != null) {
            url += `&_emissaoIni=${item.valor}`;
          }
        }
        if (item.item_id == "emissaoFim") {
          if (item.valor != null) {
            url += `&_emissaoFim=${item.valor}`;
          }
        }
        if (item.item_id == "importacaoIni") {
          if (item.valor != null) {
            url += `&_importacaoIni=${item.valor}`;
          }
        }
        if (item.item_id == "importacaoFim") {
          if (item.valor != null) {
            url += `&_importacaoFim=${item.valor}`;
          }
        }
        if (item.item_id == "vencimentoIni") {
          if (item.valor != null) {
            url += `&_vencimentoIni=${item.valor}`;
          }
        }
        if (item.item_id == "vencimentoFim") {
          if (item.valor != null) {
            url += `&_vencimentoFim=${item.valor}`;
          }
        }
        if (item.item_id == "vlrInicial") {
          if (item.valor != null) {
            let aux = item.valor;
            aux = aux.replace(/\D/g, ""); //Remode tudo o que não é dígito
            aux = aux.replace(/(\d+)(\d{2})/, "$1.$2");
            url += `&_valorIni=${aux}`;
          }
        }
        if (item.item_id == "vlrFinal") {
          if (item.valor != null) {
            let aux = item.valor;
            aux = aux.replace(/\D/g, ""); //Remode tudo o que não é dígito
            aux = aux.replace(/(\d+)(\d{2})/, "$1.$2");
            url += `&_valorFim=${aux}`;
          }
        }
      });
      this.table.urlFiltros = url;
      this.range = "tudo";
      this.getDadosApi();
    },
    updatedSelected($event) {
      if ($event) {
        this.selected = $event.slice();
      }
    },

    customFilter(items, search, filter) {
      var auxTable = this.table;
      setTimeout(function() {
        auxTable.headers.forEach(function(item) {
          if (item.value != "acoes") {
            if (!item.show) {
              var id = "#" + item.value;
              document
                .querySelectorAll(id)
                .forEach((item) => (item.style.display = "none"));
            }
          }
        });
      }, 300);

      this.table.headers.forEach(function(item) {
        if (item.value != "acoes") {
          if (!item.show) {
            var id = "#" + item.value;
            document
              .querySelectorAll(id)
              .forEach((item) => (item.style.display = "none"));
          }
        }
      });
      if (!search) {
        if (this.table.dadosFiltrados) {
          this.table.qnt_total_notas = this.table.array_todas_notas.length;
          this.table.setPages(
            this.table.array_todas_notas.length,
            this.table.pagination.rowsPerPage
          );
        }

        this.table.dadosFiltrados = false;
        this.table.arraySearch = [];

        setTimeout(function() {
          auxTable.headers.forEach(function(item) {
            if (item.value != "acoes") {
              if (!item.show) {
                var id = "#" + item.value;
                document
                  .querySelectorAll(id)
                  .forEach((item) => (item.style.display = "none"));
              }
            }
          });
        }, 10);

        return this.table.arrayNotas;
      }
      this.table.headers.forEach(function(item) {
        if (item.value != "acoes") {
          if (!item.show) {
            var id = "#" + item.value;
            document
              .querySelectorAll(id)
              .forEach((item) => (item.style.display = "none"));
          }
        }
      });

      this.table.dadosFiltrados = true;
      let notas = [];
      if (this.filtroForSearch.value != "tudo") {
        var searchLngth = search.replace(/[^0-9a-zA-Z]+/g, "").length;
        for (let i = 0; i < this.table.array_todas_notas.length; i++) {
          if (this.filtroForSearch.value.indexOf("custom") == -1) {
            if (
              this.table.array_todas_notas[i][this.filtroForSearch.value]
                .toString()
                .toLowerCase()
                .replace(/[^0-9a-zA-Z]+/g, "")
                .substr(0, searchLngth) ==
              search
                .toString()
                .toLowerCase()
                .replace(/[^0-9a-zA-Z]+/g, "")
            ) {
              notas.push(this.table.array_todas_notas[i]);
            }
          } else {
            if (
              this.table.array_todas_notas[i][this.filtroForSearch.value].value
                .toString()
                .toLowerCase()
                .replace(/[^0-9a-zA-Z]+/g, "")
                .substr(0, searchLngth) ==
              search
                .toString()
                .toLowerCase()
                .replace(/[^0-9a-zA-Z]+/g, "")
            ) {
              notas.push(this.table.array_todas_notas[i]);
            }
          }
        }
      }
      if (this.filtroForSearch.value == "tudo") {
        function new_filter(val, search) {
          return (
            val !== null &&
            ["undefined", "boolean"].indexOf(typeof val) === -1 &&
            val
              .toString()
              .toLowerCase()
              .replace(/[^0-9a-zA-Z]+/g, "")
              .indexOf(
                search
                  .toString()
                  .toLowerCase()
                  .replace(/[^0-9a-zA-Z]+/g, "")
                  .split(" ")
              ) !== -1
          );
        }
        let needleAry = search
          .toString()
          .toLowerCase()
          .split(" ")
          .filter((x) => x);
        var auxHeadersTable = this.table.headers;
        notas = this.table.array_todas_notas.filter((row) => {
          return needleAry.every((needle) => {
            return Object.keys(row).some((key) => {
              var customPesq = false;
              if (key.indexOf("custom_") != -1) {
                //caso a coluna for alguma de custom verificar se nela está setado para entrar nas opções de busca
                auxHeadersTable.forEach((e) => {
                  if (e.value == key) {
                    if (e.pesq) {
                      customPesq = true;
                      return;
                    }
                    customPesq = false;
                    return;
                  }
                });
              }
              //colunas customns possuem um objeto em seus valores, onde é preciso especificar o caminho diferente das colunas padrões
              if (customPesq) {
                return new_filter(row[key].value, needle);
              }
              return new_filter(row[key], needle);
            });
          });
        });
      }
      this.table.qnt_total_notas = notas.length;
      this.table.setPages(notas.length, this.table.pagination.rowsPerPage);

      this.table.arraySearch = notas;
      return notas;
    },
    getDadosApi: async function() {
      if (this.range == "tudo" && !this.table.urlFiltros) {
        return;
      }
      this.table.busca = true;
      this.table.loading = true;
      this.pagination.page = 1;

      if (
        this.component.name == "NFeRecebidas" &&
        this.component.tipo == "recebida"
      ) {
        this.service = new NfeService(this.$http);
        this.getItems("getNfeRecebidas", 2);
      } else if (
        this.component.name == "NFeRecebidas" &&
        this.component.tipo == "emitida"
      ) {
        this.service = new NfeService(this.$http);
        this.getItems("getNfeEmitidas", 2);
      } else if (
        this.component.name == "NFeRecebidas" &&
        this.component.tipo == "transportados"
      ) {
        this.service = new NfeService(this.$http);
        this.getItems("getNfeTransportados", 2);
      }else if (
        this.component.name == "CTE" &&
        this.component.tipo == "todos"
      ) {
        this.service = new CteService(this.$http);
        this.getItems("getCte", 2);
      } else if (
        this.component.name == "CTE" &&
        this.component.tipo == "tomados"
      ) {
        this.service = new CteService(this.$http);
        this.getItems("getCteTomados", 2);
      } else if (this.component.name == "usuario") {
        this.service = new UsuariosService(this.$http);
        this.table.arrayNotas = [];
        this.table.qnt_total_notas = this.arrayItems.length;
        this.table.setNota(this.table.arrayNotas, this.arrayItems);
        this.table.array_todas_notas = this.table.arrayNotas.slice();
        this.table.setPages(
          this.table.arrayNotas.length,
          this.table.pagination.rowsPerPage
        );
      } else if (this.component.name == "rela_usuario") {
        this.service = new UsuariosService(this.$http);
        this.getItems("relatorio", 2);
        // this.table.arrayNotas = [];
        // this.table.qnt_total_notas = this.arrayItems.length;
        // this.table.setNota(this.table.arrayNotas, this.arrayItems);
        // this.table.array_todas_notas = this.table.arrayNotas.slice();
        // this.table.setPages(
        //   this.table.arrayNotas.length,
        //   this.table.pagination.rowsPerPage
        // );
      } else if (
        this.component.name == "NFSE" &&
        this.component.tipo === "emitida" &&
        this.empresa.servicos &&
        this.empresa.servicos.robotizacao &&
        this.empresa.servicos.robotizacao.find(
          (item) => item.nomeServico === "NFSE_TOMADOS"
        )
      ) {
        this.service = new NfseService(this.$http);
        this.getItems("getNfseEmitidas", 2);
      } else if (this.component.name == "NFSE") {
        this.service = new NfseService(this.$http);
        this.getItems("getNfse", 2);
      } else if (this.component.name == "fornecedores") {
        this.service = new FornecedoresService(this.$http);
        this.getItems("getFornecedores", 2);
      } else if (this.component.name == "clientes") {
        this.service = new ClientesService(this.$http);
        this.getItems("getClientes", 2);
      } else if (this.component.name == "produtos") {
        this.service = new ProdutosService(this.$http);
        this.getItems("getProdutos", 2);
      } else if (this.component.name == "Iptu") {
        this.service = new IptuService(this.$http);
        this.getItems("getImoveis", 2);
      } else if (this.component.name == "empresa") {
        // let qtdDiferente = false;
        // let qtdBuscar = 0;

        this.service = new EmpresaService(this.$http);
        this.service
          .getEmpresasConta(this.conta.conta, 1, 10)
          .then((body) => {
            this.table.qnt_total_notas =
              body.empresas.length + body.emprs_not_admin.length;
          })
          .then(() => {
            if (JSON.stringify(this.tableEmpresas) !== "{}") {
              if (
                this.tableEmpresas.array_todas_notas.length ===
                this.table.qnt_total_notas
              ) {
                // qtdDiferente = true;
                // qtdBuscar = this.table.qnt_total_notas - this.tableEmpresas.array_todas_notas.length;
                this.table = this.tableEmpresas;
                return;
              }
              // else {
              //   this.table = this.tableEmpresas;
              //   return;
              // }
            }

            let auxQtd = this.table.qnt_total_notas;

            // if(qtdDiferente) {
            //   auxQtd = qtdBuscar;
            // }

            this.service
              .getEmpresasConta(this.conta.conta, 1, auxQtd)
              .then((body) => {
                if (body && body.empresas) {
                  // if(!qtdDiferente) {
                  this.table.arrayNotas = [];
                  // }

                  this.table.qnt_total_notas =
                    body.empresas.length + body.emprs_not_admin.length;
                  let arrayEmpresas = body.empresas.concat(
                    body.emprs_not_admin
                  );
                  this.table.setNota(
                    this.table.arrayNotas,
                    arrayEmpresas,
                    body.faturamento
                  );
                  this.table.array_todas_notas = this.table.arrayNotas.slice();
                  this.table.setPages(
                    this.table.arrayNotas.length,
                    this.table.pagination.rowsPerPage
                  );
                }
              })
              .then(() => {
                this.$store.commit("addTableEmpresas", this.table);
              });
          });
      } else if (this.component.name == "certificado") {
        // let qtdDiferente = false;
        // let qtdBuscar = 0;

        this.service = new CertificadoService(this.$http);
        this.service
          .getCertificadosConta(this.conta.conta, 1, 10)
          .then((body) => {
            if (!body.items && !body.certs_not_owner) {
              this.table.loading = false;
              return false;
            }
            let owner_length = body.certs_not_owner && body.certs_not_owner.items ? body.certs_not_owner.items.length : 0;
            this.table.qnt_total_notas =
            owner_length + body.items.length;
            return true;
          })
          .then((hasData) => {
            if (hasData) {
              if (JSON.stringify(this.tableCertificados) !== "{}") {
                if (
                  this.tableCertificados.array_todas_notas.length ===
                  this.table.qnt_total_notas
                ) {
                  // qtdDiferente = true;
                  // qtdBuscar = this.table.qnt_total_notas - this.tableCertificados.array_todas_notas.length;
                  this.table = this.tableCertificados;
                  return;
                }
                // else {
                //   this.table = this.tableCertificados;
                //   return;
                // }
              }

              let auxQtd = this.table.qnt_total_notas;

              // if(qtdDiferente) {
              //   auxQtd = qtdBuscar;
              // }

              this.service
                .getCertificadosConta(this.conta.conta, 1, auxQtd)
                .then((body) => {
                  // if(!qtdDiferente) {
                  this.table.arrayNotas = [];
                  // }
                  let owner_length = body.certs_not_owner && body.certs_not_owner.items ? body.certs_not_owner.items.length : 0;
                  this.qnt_total_notas =
                  owner_length + body.items.length;
                  let arrayEmpresas = body.items.concat(
                    body.certs_not_owner.items
                  );
                  this.table.setNota(this.table.arrayNotas, arrayEmpresas);

                  this.table.array_todas_notas = this.table.arrayNotas.slice();
                  this.table.setPages(
                    this.table.arrayNotas.length,
                    this.table.pagination.rowsPerPage
                  );
                })
                .then(() => {
                  this.$store.commit("addTableCertificados", this.table);
                });
            }
          });
      } else if (this.component.name == "conta") {
        this.service = new ContaService(this.$http);
        this.getItems("relatorio", 2);
        // this.service.relatorio(this.conta.id_usuario).then(res => {
        //   this.table.arrayNotas = [];
        //   this.table.qnt_total_notas = res.body.items
        //     ? res.body.items.length
        //     : 0;
        //   this.table.setNota(this.table.arrayNotas, res.body.items);
        //   this.table.array_todas_notas = this.table.arrayNotas.slice();
        //   this.table.setPages(
        //     this.table.arrayNotas.length,
        //     this.table.pagination.rowsPerPage
        //   );
        // });
      } else {
        throw new Error(
          `Erro ao tentar buscar items para a tabela, serviço do '${this.component.name}' não codificado`
        );
      }
    },
    getItems: async function(method, tipo) {
      // debugger;
      switch (tipo) {
        case 1:
          await this.service[method](this.empresa._id).then(function(body) {
            this.table.arrayNotas = [];
            this.table.qnt_total_notas = body.length;
            this.table.setNota(this.table.arrayNotas, body);
          });
          // console.log(12123123321 ,arrayNotas);

          this.table.qnt_total_notas = this.table.arrayNotas.length;
          this.table.array_todas_notas = this.table.arrayNotas.slice();
          this.table.setPages(
            this.table.array_todas_notas.length,
            this.table.pagination.rowsPerPage
          );
          this.conta.getNotificacoes = true;
          break;
        case 2:
          // Verifica se a quantidade de notas armazenadas no vuex é a mesma que esta no banco
          // let qtdDiferente = false;
          // Busca a diferença de notas entre o vuex e o banco
          // let qtdBuscar = 0;
          let emp = this.empresa ? this.empresa._id : "";
          let NotasPorPage = this.table.setQntPorPage(
            this.table.pagination.rowsPerPage
          );
          await this.service[method](
            1,
            NotasPorPage,
            this.empresa ? this.empresa._id : this.empresa,
            this.range,
            this.table.urlFiltros,
            this.component.tipo,
            this.conta.id_usuario
          )
            .then(function(body) {
              // if(!body._links.totalItens) {
              //   body._links.totalItens = body.items.length;
              //   body._links.self = '/imoveis/'+emp;
              // }
              // if(!body) {

              //   return false;
              // }

              this.nextPage =
                body._links && body._links.next ? body._links.next : "";
              this.table.array_todas_notas = [];
              this.table.arrayNotas = [];
              if (body != undefined && body.hasOwnProperty("items")) {
                this.table.qnt_total_notas = body._links.totalItens;
                this.table.setNota(this.table.arrayNotas, body.items);
                return true;
              }
            })
            .then(function next(v) {
              if (v) {
                this.table.arrayNotas = [];
                this.table.arrayNotas = this.setNotasByHeaders(
                  this.table.arrayNotas
                );
                return true;
              }
            })
            .then(async function next(v) {
              if (v) {
                let qtdAux = this.table.qnt_total_notas;
                // Verifica se existem dados armazenados na store ( vuex )
                if (this.component.name === "NFeRecebidas") {
                  if (
                    this.component.tipo === "recebida" &&
                    JSON.stringify(this.tableNfeRecebidas) !== "{}"
                  ) {
                    if (
                      this.tableNfeRecebidas.array_todas_notas.length ===
                      this.table.qnt_total_notas
                    ) {
                      // qtdDiferente = true;
                      // qtdBuscar = this.table.qnt_total_notas - this.tableNfeRecebidas.array_todas_notas.length;
                      this.table = this.tableNfeRecebidas;
                      return;
                      // console.log('DIFERENTE');
                      // console.log(this.table);
                    }
                    // else {
                    //   this.table = this.tableNfeRecebidas;
                    //   return;
                    // }
                  }
                  if (
                    this.component.tipo === "emitida" &&
                    JSON.stringify(this.tableNfeEmitidas) !== "{}"
                  ) {
                    if (
                      this.tableNfeEmitidas.array_todas_notas.length ===
                      this.table.qnt_total_notas
                    ) {
                      // qtdDiferente = true;
                      // qtdBuscar = this.table.qnt_total_notas - this.tableNfeEmitidas.array_todas_notas.length;
                      this.table = this.tableNfeEmitidas;
                      return;
                    }
                    // else {
                    //   this.table = this.tableNfeEmitidas;
                    //   return;
                    // }
                  }
                  if (
                    this.component.tipo === "transportados" &&
                    JSON.stringify(this.tableNfeTransportados) !== "{}"
                  ) {
                    if (
                      this.tableNfeTransportados.array_todas_notas.length ===
                      this.table.qnt_total_notas
                    ) {
                      // qtdDiferente = true;
                      // qtdBuscar = this.table.qnt_total_notas - this.tableNfeEmitidas.array_todas_notas.length;
                      this.table = this.tableNfeTransportados;
                      return;
                    }
                    // else {
                    //   this.table = this.tableNfeEmitidas;
                    //   return;
                    // }
                  }
                }

                if (this.component.name === "CTE") {
                  if (
                    this.component.tipo === "todos" &&
                    JSON.stringify(this.tableCteTodos) !== "{}"
                  ) {
                    if (
                      this.tableCteTodos.array_todas_notas.length ===
                      this.table.qnt_total_notas
                    ) {
                      // qtdDiferente = true;
                      // qtdBuscar = this.table.qnt_total_notas - this.tableCteTodos.array_todas_notas.length;
                      this.table = this.tableCteTodos;
                      return;
                    }
                    // else {
                    //   this.table = this.tableCteTodos;
                    //   return;
                    // }
                  }
                  if (
                    this.component.tipo === "tomados" &&
                    JSON.stringify(this.tableCteTomados) !== "{}"
                  ) {
                    if (
                      this.tableCteTomados.array_todas_notas.length ===
                      this.table.qnt_total_notas
                    ) {
                      // qtdDiferente = true;
                      // qtdBuscar = this.table.qnt_total_notas - this.tableCteTomados.array_todas_notas.length;
                      this.table = this.tableCteTomados;
                      return;
                    }
                    // else {
                    //   this.table = this.tableCteTomados;
                    //   return;
                    // }
                  }
                }

                // if(this.component.name === 'NFSE') {
                //   if(this.component.tipo === 'recebida' && JSON.stringify(this.tableNfseRecebidas) !== '{}') {
                //     if( this.tableNfseRecebidas.array_todas_notas.length === this.table.qnt_total_notas ) {
                //       this.table = this.tableNfseRecebidas;
                //       return;
                //     }
                //   }
                //   if( this.component.tipo === 'emitida' && JSON.stringify(this.tableNfseEmitidas) !== '{}' ) {
                //     if( this.tableNfseEmitidas.array_todas_notas.length === this.table.qnt_total_notas ) {
                //       this.table = this.tableNfseEmitidas;
                //       return;
                //     }
                //   }
                // }

                if (
                  this.component.name === "clientes" &&
                  JSON.stringify(this.tableClientes) !== "{}"
                ) {
                  if (
                    this.tableClientes.array_todas_notas.length ===
                    this.table.qnt_total_notas
                  ) {
                    // qtdDiferente = true;
                    // qtdBuscar = this.table.qnt_total_notas - this.tableClientes.array_todas_notas.length;
                    this.table = this.tableClientes;
                    return;
                  }
                  // else {
                  //   this.table = this.tableClientes;
                  //   return;
                  // }
                }

                if (
                  this.component.name === "fornecedores" &&
                  JSON.stringify(this.tableFornecedores) !== "{}"
                ) {
                  if (
                    this.tableFornecedores.array_todas_notas.length ===
                    this.table.qnt_total_notas
                  ) {
                    // qtdDiferente = true;
                    // qtdBuscar = this.table.qnt_total_notas - this.tableFornecedores.array_todas_notas.length;
                    this.table = this.tableFornecedores;
                    return;
                  }
                  // else {
                  //   this.table = this.tableFornecedores;
                  //   return;
                  // }
                }

                if (this.component.name === "produtos") {
                  if (
                    this.component.tipo === "recebida" &&
                    JSON.stringify(this.tableProdutos) !== "{}"
                  ) {
                    if (
                      this.tableProdutos.array_todas_notas.length ===
                      this.table.qnt_total_notas
                    ) {
                      // qtdDiferente = true;
                      // qtdBuscar = this.table.qnt_total_notas - this.tableProdutos.array_todas_notas.length;
                      this.table = this.tableProdutos;
                      return;
                    }
                    // else {
                    //   this.table = this.tableProdutos;
                    //   return;
                    // }
                  } else if (
                    this.component.tipo === "emitida" &&
                    JSON.stringify(this.tableProdutosEmitidas) !== "{}"
                  ) {
                    if (
                      this.tableProdutosEmitidas.array_todas_notas.length ===
                      this.table.qnt_total_notas
                    ) {
                      // qtdDiferente = true;
                      // qtdBuscar = this.table.qnt_total_notas - this.tableProdutosEmitidas.array_todas_notas.length;
                      this.table = this.tableProdutosEmitidas;
                      return;
                    }
                    // else {
                    //   this.table = this.tableProdutosEmitidas;
                    //   return;
                    // }
                  }
                }

                let auxQtd = this.table.qnt_total_notas;
                if (this.table.qnt_total_notas >= 30000) {
                  auxQtd = 5000;
                }

                // if(qtdDiferente) {
                //   auxQtd = qtdBuscar;
                //   console.log(auxQtd);
                //   this.table.qnt_total_notas = qtdAux;
                // }

                let paginas = 1;
                let auxTable = {};

                // Se possuir mais notas que a quantidade maxima, será feito o carregamento em partes.
                while (paginas) {
                  if (paginas > 1) {
                    this.$store.commit("addBuscaCTE", true);
                  }
                  this.table.loading = true;
                  await this.service[method](
                    paginas,
                    auxQtd,
                    this.empresa ? this.empresa._id : this.empresa,
                    this.range,
                    this.table.urlFiltros,
                    this.component.tipo,
                    this.conta.id_usuario
                  )
                    .then(function(body) {
                      this.nextPage =
                        body._links && body._links.next ? body._links.next : "";
                      //seta todas as notas
                      if (paginas === 1) {
                        this.table.array_todas_notas = [];
                        this.table.arrayNotas = [];
                      }
                      this.table.setNota(
                        this.table.array_todas_notas,
                        body.items
                      );
                    })
                    .then(function() {
                      //seta os headers na tabela
                      this.table.array_todas_notas = this.setNotasByHeaders(
                        this.table.array_todas_notas
                      );
                    })
                    .then(function() {
                      //seta os headers qntd de pagina
                      this.table.qnt_total_paginas = this.table.setPages(
                        this.table.array_todas_notas.length,
                        this.table.pagination.rowsPerPage
                      );
                    })
                    .then(function() {
                      //seta as notas notas exbidas na tela
                      this.table.arrayNotas = this.table.array_todas_notas.slice();
                    })
                    .then(function() {
                      //Quando não houver nota no periodo de 7 dias, troca para busca completa.
                      if (
                        this.component.enable.rangeDate &&
                        this.range == "mesAtual" &&
                        this.table.array_todas_notas.length == 0 &&
                        this.table.firstAcess
                      ) {
                        this.table.snack.text = `Ausência de dados neste mês.\n Para uma nova busca altere o filtro.`;
                        this.table.snackDefault();
                        this.table.snack.time = 4000;
                        this.table.snack.show = true;
                        this.table.firstAcess = false;
                        let that = this;
                        // setTimeout(function() {
                        //   that.range = "tudo";
                        // }, 4000);
                      }
                    })
                    .then(function() {
                      //busca notificacoes
                      this.conta.getNotificacoes = true;
                    });

                  if (this.nextPage) {
                    paginas = this.nextPage.substring(
                      this.nextPage.indexOf("=") + 1,
                      this.nextPage.indexOf("&")
                    );
                    this.table.loading = false;
                    // if(paginas < 9){
                    //   let test = this.nextPage.substr(12,1);
                    //   paginas = test;

                    //   this.table.loading = false;
                    // }else {
                    //   let test = this.nextPage.substr(12,2);
                    //   paginas = test;
                    //   this.table = {...this.table};
                    //   this.table.loading = false;
                    // }
                  } else {
                    // this.table = {...this.table};
                    this.$store.commit("addBuscaCTE", false);
                    paginas = 0;
                  }
                }
              }
              this.table.loading = false;

              // Armazenar tabelas no vuex
              if (this.component.name === "NFeRecebidas") {
                if (this.component.tipo === "recebida") {
                  this.$store.commit("addTableNfeRecebidas", this.table);
                } else if (this.component.tipo === "emitida") {
                  this.$store.commit("addTableNfeEmitidas", this.table);
                } else if (this.component.tipo === "transportados") {
                  this.$store.commit("addTableNfeTransportados", this.table);
                } else {
                  return;
                }
              } else if (this.component.name === "CTE") {
                if (this.component.tipo === "todos") {
                  this.$store.commit("addTableCteTodos", this.table);
                } else if (this.component.tipo === "tomados") {
                  this.$store.commit("addTableCteTomados", this.table);
                } else {
                  return;
                }
              } else if (this.component.name === "NFSE") {
                if (this.component.tipo === "recebida") {
                  this.$store.commit("addTableNfseRecebidas", this.table);
                } else if (this.component.tipo === "emitida") {
                  this.$store.commit("addTableNfseEmitidas", this.table);
                } else {
                  return;
                }
              } else if (this.component.name === "clientes") {
                this.$store.commit("addTableClientes", this.table);
              } else if (this.component.name === "fornecedores") {
                this.$store.commit("addTableFornecedores", this.table);
              } else if (this.component.name === "produtos") {
                if (this.component.tipo === "recebida") {
                  this.$store.commit("addTableProdutos", this.table);
                } else if (this.component.tipo === "emitida") {
                  this.$store.commit("addTableProdutosEmitidas", this.table);
                } else {
                  return;
                }
              } else {
                return;
              }
            });
          break;
        default:
          throw new Error("Erro ao fazer requisição");
      }
      if (tipo == 1) {
        this.table.arrayNotas = this.setNotasByHeaders(
          this.table.arrayNotas
        ).slice();
        this.table.array_todas_notas = this.table.arrayNotas.slice();
      }
    },
    selectRow: function(props) {
      var index = undefined;
      if (this.table.selected) {
        // console.log(props.item);
        if (!this.table.selected.find((item) => item._id == props.item._id)) {
          this.table.selected.push(props.item);
        } else {
          index = this.table.selected.findIndex(
            (item) => item._id == props.item._id
          );
          if (index != undefined) {
            this.table.selected.splice(index, 1);
          }
        }
      }
    },
    setNotasByHeaders: function(array) {
      // return this.table.getHeaders();
      // this.table.headers = this.table.getHeaders();
      // return array
      var tipoHeader = "";
      this.component.name == "clientes"
        ? (tipoHeader = "clienteHeader")
        : this.component.name == "fornecedores"
        ? (tipoHeader = "fornecHeader")
        : this.component.name == "CTE" && this.component.tipo == "todos"
        ? (tipoHeader = "cteHeaderRecebidos")
        : this.component.name == "CTE" && this.component.tipo == "tomados"
        ? (tipoHeader = "cteHeaderTomados")
        : this.component.name == "produtos" && this.component.tipo == "recebida"
        ? (tipoHeader = "produtoHeaderRecebidos")
        : this.component.name == "produtos" && this.component.tipo == "emitida"
        ? (tipoHeader = "produtoHeaderEmitidos")
        : this.component.name.indexOf("NFe") != -1 &&
          this.component.tipo == "recebida"
        ? (tipoHeader = "nfeHeaderRecebidas")
        : this.component.name.indexOf("NFe") != -1 &&
          this.component.tipo == "emitida"
        ? (tipoHeader = "nfeHeaderEmitidas")
        : this.component.name.indexOf("NFe") != -1 &&
          this.component.tipo == "transportados"
        ? (tipoHeader = "nfeHeaderTransportados")
        : this.component.name == "NFSE" && this.component.tipo == "emitida"
        ? (tipoHeader = "nfseHeaderEmitidos")
        : this.component.name == "NFSE" && this.component.tipo == "recebida"
        ? (tipoHeader = "nfseHeaderRecebidos")
        : this.component.name == "Iptu"
        ? (tipoHeader = "iptuHeader")
        : (tipoHeader = "");

      if (
        this.empresa != undefined &&
        this.empresa[tipoHeader] != undefined &&
        this.empresa[tipoHeader].length > 0 &&
        this.empresa.servicos &&
        this.empresa.servicos.robotizacao &&
        this.empresa.servicos.robotizacao.find(
          (item) => item.nomeServico === "NFSE_TOMADOS"
        ) &&
        this.table.getHeaders(true).length === this.empresa[tipoHeader].length
      ) {
        let empresa_id = this.empresa._id;
        let auxNotas = array;
        let arrayNfe = [];
        this.table.headers = [];
        let i = 0;
        var cont_c_column = 0;

        // ADICIONANDO O CAMPO SISTEMA NA TABELA
        if (
          tipoHeader === "cteHeaderTomados" ||
          tipoHeader === "cteHeaderRecebidos"
        ) {
          const sistema = {
            enable: true,
            id: "verProc",
            pesq: true,
            show: true,
            titulo: "Sistema",
          };
          const data_erp = {
            enable: true,
            id: "data_erp",
            pesq: false,
            show: true,
            titulo: "Data ERP",
          };
          const departamento = {
            enable: true,
            id: "departamento",
            pesq: false,
            show: true,
            titulo: "Departamento",
          };

          const modal = {
            enable: true,
            id: "modal",
            pesq: true,
            show: true,
            titulo: "Modal",
          };
          


          let possuiDepartamento = false;
          let possuiDataerp = false;
          let possuiSistema = false;
          let possuiModal = false;


          this.empresa[tipoHeader].forEach((header) => {
            if (header.id === "verProc") {
              possuiSistema = true;
            }
            if (header.id === "data_erp") {
              possuiDataerp = true;
            }
            if (header.id === "departamento") {
              possuiDepartamento = true;
            }
            if (header.id === "modal") {
              possuiModal = true;
            }
         
          });

          // Adiciona o campo sistema para o header
          if (!possuiDataerp) {
            this.empresa[tipoHeader].push(data_erp);
          }
          if (!possuiSistema) {
            this.empresa[tipoHeader].push(sistema);
          }
          if (!possuiDepartamento) {
            this.empresa[tipoHeader].push(departamento);
          }
          if (!possuiModal) {
            this.empresa[tipoHeader].push(modal);
          }
        }

        // ADICIONANDO O CAMPO MANIFESTAÇÃO NA TABELA
        if (tipoHeader === "cteHeaderTomados") {
          const manifestacao = {
            enable: true,
            id: "manifestacao",
            value: "manifestacao",
            pesq: true,
            show: true,
            titulo: "Manifestação",
          };
          const id_fluig = {
            enable: true,
            id: "id_fluig",
            pesq: true,
            show: true,
            titulo: "Id Fluig",
          };
          const log_statusErp = {
            enable: true,
            id: "log_statusErp",
            pesq: false,
            show: false,
            titulo: "log_statusErp",
          };
          const log_statusErpDois = {
            enable: true,
            id: "log_statusErpDois",
            pesq: false,
            show: false,
            titulo: "log_statusErpDois",
          };
          const statusErpDois = {
            enable: true,
            id: "statusErpDois",
            pesq: false,
            show: true,
            titulo: "statusErpDois",
          };
          let possuiIdFluig = false;
          let possuiLogStatusErp = false;
          let possuiLogStatusErpDois = false;
          let possuiStatusErpDois = false;
          let possuiManifestacao = false;
          this.empresa[tipoHeader].forEach((header) => {
            if (header.id === "manifestacao") {
              possuiManifestacao = true;
            }
            if (header.id === "id_fluig") {
              possuiIdFluig = true;
            }
            if (header.id === "log_statusErp") {
              possuiLogStatusErp = true;
            }
            if (header.id === "log_statusErpDois") {
              possuiLogStatusErpDois = true;
            }
            if (header.id === "statusErpDois") {
              possuiStatusErpDois = true;
            }
          });

          // Adiciona o campo manifestacao para o header
          if (!possuiManifestacao) {
            this.empresa[tipoHeader].push(manifestacao);
          }
          if (!possuiIdFluig) {
            this.empresa[tipoHeader].push(id_fluig);
          }
          if (!possuiLogStatusErp) {
            this.empresa[tipoHeader].push(log_statusErp);
          }
          if (!possuiLogStatusErpDois) {
            this.empresa[tipoHeader].push(log_statusErpDois);
          }
          if (!possuiStatusErpDois) {
            this.empresa[tipoHeader].push(statusErpDois);
          }
        }

        // ADICIONANDO O CAMPO DOCZIP NA TABELA
        if (
          tipoHeader === "nfeHeaderRecebidas" ||
          tipoHeader === "nfeHeaderEmitidas"
        ) {
          // Cria o docZip para adicionar ao header nfeHeaderRecebidas
          const docZip = {
            enable: true,
            id: "docZip",
            pesq: false,
            show: false,
            titulo: "docZip",
          };

          const natOp = {
            enable: true,
            id: "natOp",
            pesq: true,
            show: true,
            titulo: "Natureza Operação",
          };

          const infAd = {
            enable: true,
            id: "inf_ad",
            pesq: false,
            show: true,
            titulo: "Informações adicionais",
          };
          const produtos = {
            enable: true,
            id: "produtos",
            pesq: false,
            show: true,
            titulo: "Produtos",
          };
          const verProc = {
            enable: true,
            id: "verProc",
            pesq: false,
            show: true,
            titulo: "Sistema",
          };
          const valorFcp = {
            enable: true,
            id: "valorFcp",
            pesq: false,
            show: true,
            titulo: "Valor do FCP",
          };
          const valorBcst = {
            enable: true,
            id: "valorBcst",
            pesq: false,
            show: true,
            titulo: "Valor do BCST",
          };
          const data_erp = {
            enable: true,
            id: "data_erp",
            pesq: false,
            show: true,
            titulo: "Data ERP",
          };
          const departamento = {
            enable: true,
            id: "departamento",
            pesq: false,
            show: true,
          };
          const log_statusErp = {
            enable: true,
            id: "log_statusErp",
            pesq: true,
            show: false,
          };
          const log_statusErpDois = {
            enable: true,
            id: "log_statusErpDois",
            pesq: true,
            show: false,
          };
          const statusErpDois = {
            enable: true,
            id: "statusErpDois",
            pesq: true,
            show: true,
          };
          const id_fluig = {
            enable: true,
            id: "id_fluig",
            pesq: true,
            show: true,
            titulo: "Id Fluig"
          };
          const posFechamento = {
            enable: true,
            id: "posFechamento",
            pesq: true,
            show: true,
            titulo: "Pós Faturamento"
          }

          let possuiDocZip = false;
          let possuiNatOp = false;
          let possuiInfAd = false;
          let possuiProdutos = false;
          let possuiSistem = false;
          let possuiDataerp = false;
          let possuiFcp = false;
          let possuiBcst = false;
          let possuiDepartamento = false;
          let possuilog_statusErp = false;
          let possuilog_statusErpDois = false;
          let possuiStatusErpDois = false;
          let possuiIdFluig= false;
          let possuiPosFechamento= false;

          this.empresa[tipoHeader].forEach((header) => {
            if (header.id === "docZip") {
              possuiDocZip = true;
            }

            if (header.id === "natOp") {
              possuiNatOp = true;
            }

            if (header.id === "inf_ad") {
              possuiInfAd = true;
            }

            if (header.id === "verProc") {
              possuiSistem = true;
            }
            if (header.id === "valorFcp") {
              possuiFcp = true;
            }
            if (header.id === "valorBcst") {
              possuiBcst = true;
            }

            if (header.id === "data_erp") {
              possuiDataerp = true;
            }
            if (header.id === "departamento") {
              possuiDepartamento = true;
            }
            if (header.id === "log_statusErp") {
              possuilog_statusErp = true;
            }
            if (header.id === "log_statusErpDois") {
              possuilog_statusErpDois = true;
            }
            if (header.id === "statusErpDois") {
              possuiStatusErpDois = true;
            }
            if (header.id === "produtos") {
              possuiProdutos = true;
            }
            if (header.id === "id_fluig") {
              possuiIdFluig = true;
            }
            if (header.id === "posFechamento") {
              possuiPosFechamento = true;
            }
          });

          // Adiciona o docZip para o header
          try {
            if (!possuiDocZip) {
              this.empresa[tipoHeader].push(docZip);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiNatOp) {
              this.empresa[tipoHeader].push(natOp);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiInfAd) {
              this.empresa[tipoHeader].push(infAd);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiProdutos) {
              this.empresa[tipoHeader].push(produtos);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiSistem) {
              this.empresa[tipoHeader].push(verProc);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiFcp) {
              this.empresa[tipoHeader].push(valorFcp);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiBcst) {
              this.empresa[tipoHeader].push(valorBcst);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiDataerp) {
              this.empresa[tipoHeader].push(data_erp);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiDepartamento) {
              this.empresa[tipoHeader].push(departamento);
            }
          } catch (error) {
                console.log(error)
          }
          try {
            if (!possuilog_statusErp) {
              this.empresa[tipoHeader].push(log_statusErp);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuilog_statusErpDois) {
              this.empresa[tipoHeader].push(log_statusErpDois);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiStatusErpDois) {
              this.empresa[tipoHeader].push(statusErpDois);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiIdFluig) {
              this.empresa[tipoHeader].push(id_fluig);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiPosFechamento) {
              this.empresa[tipoHeader].push(posFechamento);
            }
          } catch (error) {
              console.log(error)
          }
        }
        if (
          tipoHeader === "nfseHeaderRecebidos" ||
          tipoHeader === "nfseHeaderEmitidos"
        ) {

          if (tipoHeader === 'nfseHeaderEmitidos'){
            const pdv = {
            enable: true,
            id: "pdv",
            pesq: false,
            show: true,
            titulo: "Pdv"
          }
          const numero_pdv = {
            enable: true,
            id: "numero_pdv",
            pesq: false,
            show: true,
            titulo: "Numero do Pdv"
          }

          const data_pdv = {
            enable: true,
            id: "data_pdv",
            pesq: false,
            show: true,
            titulo: "Data Pdv"
          }

          let possuiPdv = false;
          let possuiNumeroPdv = false;
          let possuiDataPdv = false;



          this.empresa[tipoHeader].forEach((header) => {
            if (header.id === 'pdv') { 
              possuiPdv = true;
            }

            if (header.id === 'numero_pdv') {
              possuiNumeroPdv = true;
            }
            
            if (header.id === 'data_pdv') {
              possuiDataPdv = true;
            }
          });
            if (!possuiPdv){
              this.empresa[tipoHeader].push(pdv)
            }
            if (!possuiNumeroPdv){
              this.empresa[tipoHeader].push(numero_pdv)
            }

            if (!possuiDataPdv){
              this.empresa[tipoHeader].push(data_pdv)
            }
          }



          const posFechamento = {
            enable: true,
            id: "posFechamento",
            pesq: true,
            show: true,
            titulo: "Pós Faturamento"
          }


          const data_erp = {
            enable: true,
            id: "data_erp",
            pesq: false,
            show: true,
            titulo: "Data ERP",
          };

          const gzipPath = {
            enable: true,
            id: "gzipPath",
            pesq: false,
            show: false,
            titulo: "gzipPath",
          };

          const status_escrituracao = {
            enable: true,
            id: "status_escrituracao",
            pesq: false,
            show: true,
            titulo: "NFTS",
          };

          const id_fluig = {
            enable: true,
            id: "id_fluig",
            pesq: true,
            show: true,
            titulo: "Id Fluig"
          };

          const log_statusErp = {
            enable: true,
            id: "log_statusErp",
            pesq: false,
            show: false,
            titulo: "log integração ERP",
          };
          const log_statusErpDois = {
            enable: true,
            id: "log_statusErpDois",
            pesq: false,
            show: false,
            titulo: "log integração ERP Dois",
          };
          const statusErpDois = {
            enable: true,
            id: "statusErpDois",
            pesq: false,
            show: true,
            titulo: "Status ERP Dois"
          };
        
          const log_escrituracao = {
            enable: true,
            id: "log_escrituracao",
            pesq: false,
            show: false,
            titulo: "log_escrituracao",
          };
          const pathPdfMotor = {
            enable: true,
            id: "pathPdfMotor",
            pesq: false,
            show: false,
            titulo: "pathPdfMotor",
          };
          const nome_municipio = {
            enable: true,
            id: "nome_municipio",
            pesq: false,
            show: true,
            titulo: "Nome Município",
          };
          const simples_nacional = {
            enable: true,
            id: "simples_nacional",
            pesq: true,
            show: true,
            titulo: "Simples Nacional",
          };


          let possuiDataerp = false;
          let possuiGzipPath = false;
          let possuiLogEscrituracao = false;
          let possuiNfts = false;
          let possuiNomeMunicipio = false;
          let possuiSimplesNacional = false;
          let possuiPathPdfMotor = false;
          let possuiLogStatusErp = false;
          let possuiLogStatusErpDois = false;
          let possuiStatusErpDois = false;
          let possuiIdFluig = false;
          let possuiPosFechamento = false;

          this.empresa[tipoHeader].forEach((header) => {
            if (header.id === "data_erp") {
              possuiDataerp = true;
            }
            if(header.id === 'gzipPath') {
		          possuiGzipPath = true;
            }
            if (header.id === "status_escrituracao") {
              possuiNfts = true;
            }
            if (header.id === "log_statusErp") {
              possuiLogStatusErp = true;
            }
            if (header.id === "log_statusErpDois") {
              possuiLogStatusErpDois = true;
            }
            if (header.id === "statusErpDois") {
              possuiStatusErpDois = true;
            }
            if (header.id === "id_fluig") {
              possuiIdFluig = true;
            }
            if (header.id === "nome_municipio") {
              possuiNomeMunicipio = true;
            }
            if (header.id === "simples_nacional") {
              possuiSimplesNacional = true;
            }
            if (header.id === "log_escrituracao") {
              possuiLogEscrituracao = true;
            }
            if (header.id === "pathPdfMotor") {
              possuiPathPdfMotor = true;
            } 
            if (header.id === 'posFechamento') {              
              possuiPosFechamento = true;
            }

          });

          if (!possuiDataerp) {
            this.empresa[tipoHeader].push(data_erp);
          }
          if (!possuiGzipPath) {
            this.empresa[tipoHeader].push(gzipPath)
          }
          if (!possuiNfts) {
            this.empresa[tipoHeader].push(status_escrituracao)
          }
          if (!possuiLogStatusErp) {
            this.empresa[tipoHeader].push(log_statusErp)
          }
          if (!possuiLogStatusErpDois) {
            this.empresa[tipoHeader].push(log_statusErpDois)
          }
          if (!possuiStatusErpDois) {
            this.empresa[tipoHeader].push(statusErpDois)
          }
          if(!possuiIdFluig){
            this.empresa[tipoHeader].push(id_fluig)
          }
          if (!possuiNomeMunicipio) {
            this.empresa[tipoHeader].push(nome_municipio)
          }
          if (!possuiSimplesNacional) {
            this.empresa[tipoHeader].push(simples_nacional)
          }
          if (!possuiLogEscrituracao) {
            this.empresa[tipoHeader].push(log_escrituracao)
          }
          if (!possuiPathPdfMotor) {
            this.empresa[tipoHeader].push(pathPdfMotor)
          }
          if (!possuiPosFechamento){
              this.empresa[tipoHeader].push(posFechamento)
            }
        }

        this.empresa[tipoHeader].forEach((item) => {
          let obj = {};
          obj["text"] = item.titulo;
          obj["value"] = item.id;
          obj["show"] = item.show;
          obj["pesq"] = item.pesq;
          obj["enable"] = item.enable;

          this.table.headers.push(obj);
        });
        while (i < auxNotas.length) {
          let objNfe = {};
          cont_c_column = 0;
          this.empresa[tipoHeader].forEach((item) => {
            if (
              item.id.indexOf("custom") == -1 &&
              item.id.indexOf("acoes") == -1
            ) {
              objNfe[item.id] = auxNotas[i][item.id];
              if (item.show) {
                document.querySelectorAll(`#${item.id}`).forEach((item) => {
                  item.display = "table-cell";
                  item.removeAttribute("style");
                });
              }
            } else if (item.id.indexOf("custom") != -1) {
              item.id;
              if (
                auxNotas[i].customValues != undefined &&
                auxNotas[i].customValues.length > 0 &&
                cont_c_column < auxNotas[i].customValues.length &&
                auxNotas[i].customValues[cont_c_column] != null &&
                item.id == auxNotas[i].customValues[cont_c_column].key
              ) {
                let newObjCustom = {};
                if (
                  this.component.name == "produtos" ||
                  this.component.name == "fornecedores" ||
                  this.component.name == "clientes"
                ) {
                  if (
                    auxNotas[i].customValues[cont_c_column].key.split("_")[2] ==
                    empresa_id
                  ) {
                    newObjCustom["value"] =
                      auxNotas[i].customValues[cont_c_column].value;
                    newObjCustom["key"] =
                      auxNotas[i].customValues[cont_c_column].key;
                    objNfe[item.id] = newObjCustom;
                  } else {
                    console.log(
                      "Item possui coluna customizada que não é desta empresa"
                    );
                  }
                } else {
                  newObjCustom["value"] =
                    auxNotas[i].customValues[cont_c_column].value;
                  newObjCustom["key"] =
                    auxNotas[i].customValues[cont_c_column].key;
                  objNfe[item.id] = newObjCustom;
                }

                cont_c_column++;
              } else {
                let newObjCustom = {};
                newObjCustom["value"] = "";
                newObjCustom["key"] = item.id;
                objNfe[item.id] = newObjCustom;
                cont_c_column++;
              }
            }
          });
          arrayNfe.push(objNfe);
          i++;
        }

        if (
          tipoHeader === "nfeHeaderRecebidas" ||
          tipoHeader === "nfeHeaderEmitidas"
        ) {
          return this.setDocZip(arrayNfe, auxNotas);
        } else {
          return arrayNfe;
        }
      } else if (
        this.empresa != undefined &&
        this.empresa[tipoHeader] != undefined &&
        this.empresa[tipoHeader].length > 0
      ) {
        let empresa_id = this.empresa._id;
        let auxNotas = array;
        let arrayNfe = [];
        this.table.headers = [];
        let i = 0;
        var cont_c_column = 0;

        // ADICIONANDO O CAMPO SISTEMA NA TABELA
        if (
          tipoHeader === "cteHeaderTomados" ||
          tipoHeader === "cteHeaderRecebidos"
        ) {
          const sistema = {
            enable: true,
            id: "verProc",
            pesq: true,
            show: true,
            titulo: "Sistema",
          };
          const data_erp = {
            enable: true,
            id: "data_erp",
            pesq: true,
            show: true,
            titulo: "Data ERP",
          };
          const departamento = {
            enable: true,
            id: "departamento",
            pesq: true,
            show: true,
            titulo: "Departamento",
          };
          const modal = {
            enable: true,
            id: "modal",
            pesq: true,
            show: true,
            titulo: "Modal",
          };
          const id_fluig = {
            enable: true,
            id: "id_fluig",
            pesq: true,
            show: true,
            titulo: "Id Fluig",
          };
          const log_statusErp = {
            enable: true,
            id: "log_statusErp",
            pesq: false,
            show: false,
            titulo: "log_statusErp",
          };
          const log_statusErpDois = {
            enable: true,
            id: "log_statusErpDois",
            pesq: false,
            show: false,
            titulo: "log_statusErpDois",
          };
          const statusErpDois = {
            enable: true,
            id: "statusErpDois",
            pesq: false,
            show: true,
            titulo: "statusErpDois",
          };

          let possuiModal = false;
          let possuiDepartamento = false;
          let possuiDataerp = false;
          let possuiSistema = false;
          let possuiIdFluig = false;
          let possuiLogStatusErp = false;
          let possuiLogStatusErpDois = false;
          let possuiStatusErpDois = false;

          this.empresa[tipoHeader].forEach((header) => {
            if (header.id === "verProc") {
              possuiSistema = true;
            }
            if (header.id === "modal") {
              possuiModal = true;
            }
            if (header.id === "data_erp") {
              possuiDataerp = true;
            }
            if (header.id === "departamento") {
              possuiDepartamento = true;
            }
            if (header.id === "id_fluig") {
              possuiIdFluig = true;
            }
            if (header.id === "log_statusErp") {
              possuiLogStatusErp = true;
            }
            if (header.id === "log_statusErpDois") {
              possuiLogStatusErpDois = true;
            }
            if (header.id === "statusErpDois") {
              possuiStatusErpDois = true;
            }
          });

          // Adiciona o campo sistema para o header
          if (!possuiModal) {
            this.empresa[tipoHeader].push(modal);
          }
          if (!possuiSistema) {
            this.empresa[tipoHeader].push(sistema);
          }
          if (!possuiDataerp) {
            this.empresa[tipoHeader].push(data_erp);
          }
          if (!possuiDepartamento) {
            this.empresa[tipoHeader].push(departamento);
          }
          if (!possuiIdFluig) {
            this.empresa[tipoHeader].push(id_fluig);
          }
          if (!possuiLogStatusErp) {
            this.empresa[tipoHeader].push(log_statusErp);
          }
          if (!possuiLogStatusErpDois) {
            this.empresa[tipoHeader].push(log_statusErpDois);
          }
          if (!possuiStatusErpDois) {
            this.empresa[tipoHeader].push(statusErpDois);
          }
        }
        if (
          tipoHeader === "nfseHeaderRecebidos" ||
          tipoHeader === "nfseHeaderEmitidos"
        ) {

          if (tipoHeader === 'nfseHeaderEmitidos'){
            const pdv = {
            enable: true,
            id: "pdv",
            pesq: false,
            show: true,
            titulo: "Pdv"
            }
            const numero_pdv = {
              enable: true,
              id: "numero_pdv",
              pesq: false,
              show: true,
              titulo: "Numero do Pdv"
            }

            const data_pdv = {
              enable: true,
              id: "data_pdv",
              pesq: false,
              show: true,
              titulo: "Data Pdv"
            }
            

            let possuiPdv = false;
            let possuiNumeroPdv = false;
            let possuiDataPdv = false;
            



            this.empresa[tipoHeader].forEach((header) => {
              if (header.id === 'pdv') { 
                possuiPdv = true;
              }

              if (header.id === 'numero_pdv') {
                possuiNumeroPdv = true;
              }
              
              if (header.id === 'data_pdv') {
                possuiDataPdv = true;
              }
            
            });
              if (!possuiPdv){
                this.empresa[tipoHeader].push(pdv)
              }
              if (!possuiNumeroPdv){
                this.empresa[tipoHeader].push(numero_pdv)
              }
            
              if (!possuiDataPdv){
                this.empresa[tipoHeader].push(data_pdv)
              }
            
          }
          const data_erp = {
            enable: true,
            id: "data_erp",
            pesq: false,
            show: true,
            titulo: "Data ERP",
          };
          const status_escrituracao = {
            enable: true,
            id: "status_escrituracao",
            pesq: false,
            show: true,
            titulo: "NFTS",
          };
          const log_escrituracao = {
            enable: true,
            id: "log_escrituracao",
            pesq: false,
            show: false,
            titulo: "log_escrituracao",
          };
          const log_statusErp = {
            enable: true,
            id: "log_statusErp",
            pesq: false,
            show: false,
            titulo: "log_statusErp",
          };
          const log_statusErpDois = {
            enable: true,
            id: "log_statusErpDois",
            pesq: false,
            show: false,
            titulo: "log_statusErpDois",
          };
          const statusErpDois = {
            enable: true,
            id: "statusErpDois",
            pesq: false,
            show: true,
            titulo: "statusErpDois",
          };
          const id_fluig = {
            enable: true,
            id: "id_fluig",
            pesq: false,
            show: false,
            titulo: "Id Fluig",
          };
          const pathPdfMotor = {
            enable: true,
            id: "pathPdfMotor",
            pesq: false,
            show: false,
            titulo: "pathPdfMotor",
          };
          const nome_municipio = {
            enable: true,
            id: "nome_municipio",
            pesq: true,
            show: true,
            titulo: "Nome Município",
          };
          const simples_nacional = {
            enable: true,
            id: "simples_nacional",
            pesq: true,
            show: true,
            titulo: "Simples Nacional",
          };
          const numeroPedido = {
            enable: true,
            id: "numeroPedido",
            pesq: true,
            show: true,
            titulo: "Número do pedido",
          };
          const posFechamento = {
            enable: true,
            id: "posFechamento",
            pesq: true,
            show: true,
            titulo: "Pós Fechamento",
          };
          const valorTotalRecebido = {
            enable: true,
            id: "valorTotalRecebido",
            pesq: true,
            show: true,
            titulo: "Valor Recebido",
          };
          const provedor = {
            enable: true,
            id: "provedor",
            pesq: true,
            show: true,
            titulo: "Provedor",
          };
          const documento = {
            enable: true,
            id: "documento",
            pesq: true,
            show: true,
            titulo: "Documento"
          };
          const tipoTomador = {
            enable: true,
            id: "tipoTomador",
            pesq: true,
            show: true,
            titulo: "Tipo Tomador"
          };
          const nomeArquivo = {
            enable: true,
            id: "nomeArquivo",
            pesq: true,
            show: true,
            titulo: "Nome Arquivo"
          };
          
          const gzipPath = {
            enable: true,
            id: "gzipPath",
            pesq: false,
            show: false,
            titulo: "gzipPath",
          };

          let possuiNfts = false;
          let possuiDataerp = false;
          let possuiGzipPath = false;
          let possuiNomeMunicipio = false;
          let possuiLogEscrituracao = false;
          let possuiSimplesNacional = false;
          let possuiPathPdfMotor = false;
          let possuiLogStatusErp = false;
          let possuiLogStatusErpDois = false;
          let possuiStatusErpDois = false;
          let possuiIdFluig = false;
          let possuiNumeroPedido = false;
          let possuiPosFechamento = false;
          let possuiValorTotalRecebido = false;
          let possuiProvedor = false;
          let possuiDocumento = false;
          let possuiTipoTomador = false;
          let possuiNomeArquivo = false;
          
          this.empresa[tipoHeader].forEach((header) => {
            if (header.id === "data_erp") {
              possuiDataerp = true;
            }
            if (header.id === "status_escrituracao") {
              possuiNfts = true;
            }
            if (header.id === "nome_municipio") {
              possuiNomeMunicipio = true;
            }
            if (header.id === "simples_nacional") {
              possuiSimplesNacional = true;
            }
            if(header.id === 'gzipPath') {
		          possuiGzipPath = true;
            }
            if (header.id === "log_escrituracao") {
              possuiLogEscrituracao = true;
            }
            if (header.id === "log_statusErp") {
              possuiLogStatusErp = true;
            }
            if (header.id === "log_statusErpDois") {
              possuiLogStatusErpDois = true;
            }
            if (header.id === "statusErpDois") {
              possuiStatusErpDois = true;
            }
            if (header.id === "id_fluig") {
              possuiIdFluig = true;
            }
            if (header.id === "pathPdfMotor") {
              possuiPathPdfMotor = true;
            }
            if (header.id === "numeroPedido") {
              possuiNumeroPedido = true;
            }
            if (header.id === "posFechamento") {
              possuiPosFechamento = true;
            }
            if (header.id === "valorTotalRecebido") {
              possuiValorTotalRecebido = true;
            }
            if (header.id === "provedor") {
              possuiProvedor = true;
            }
            if (header.id === 'documento') {
              possuiDocumento = true;
            }
            if (header.id === 'tipoTomador') {
              possuiTipoTomador = true;
            }
            if (header.id === 'nomeArquivo') {
              possuiNomeArquivo = true;
            }
          });

          if (!possuiDataerp) {
            this.empresa[tipoHeader].push(data_erp);
          }
          if (!possuiNfts) {
            this.empresa[tipoHeader].push(status_escrituracao);
          }
          if (!possuiLogStatusErp) {
            this.empresa[tipoHeader].push(log_statusErp);
          }
          if (!possuiLogStatusErpDois) {
            this.empresa[tipoHeader].push(log_statusErpDois);
          }
          if (!possuiStatusErpDois) {
            this.empresa[tipoHeader].push(statusErpDois);
          }
          if (!possuiIdFluig) {
            this.empresa[tipoHeader].push(id_fluig);
          }
          if (!possuiNomeMunicipio) {
            this.empresa[tipoHeader].push(nome_municipio);
          }
          if (!possuiSimplesNacional) {
            this.empresa[tipoHeader].push(simples_nacional);
          }
          if (!possuiGzipPath) {
            this.empresa[tipoHeader].push(gzipPath)
          }
          if (!possuiLogEscrituracao) {
            this.empresa[tipoHeader].push(log_escrituracao)
          }
          if (!possuiPathPdfMotor) {
            this.empresa[tipoHeader].push(pathPdfMotor)
          }
          if (!possuiNumeroPedido) {
            this.empresa[tipoHeader].push(numeroPedido)
          }
          if (!possuiPosFechamento) {
            this.empresa[tipoHeader].push(posFechamento)
          }
          if (!possuiValorTotalRecebido) {
            this.empresa[tipoHeader].push(valorTotalRecebido)
          }
          if (!possuiProvedor) {
            this.empresa[tipoHeader].push(provedor)
          }
          if (!possuiDocumento){
              this.empresa[tipoHeader].push(documento)
          }
          if (!possuiTipoTomador){
              this.empresa[tipoHeader].push(tipoTomador)
          }
          if (!possuiNomeArquivo){
              this.empresa[tipoHeader].push(nomeArquivo)
          }
        }

        if (
          tipoHeader === "nfeHeaderRecebidas" ||
          tipoHeader === "nfeHeaderEmitidas" ||
          tipoHeader === "nfeHeaderTransportados" 
          ) {
          // ADICIONANDO O CAMPO DOCZIP NA TABELA
          // Cria o docZip para adicionar ao header nfeHeaderRecebidas
          const docZip = {
            enable: true,
            id: "docZip",
            pesq: false,
            show: false,
            titulo: "docZip",
          };

          const natOp = {
            enable: true,
            id: "natOp",
            pesq: true,
            show: true,
            titulo: "Natureza Operação",
          };

          const infAd = {
            enable: true,
            id: "inf_ad",
            pesq: false,
            show: true,
            titulo: "Informações adicionais",
          };
          const produtos = {
            enable: true,
            id: "produtos",
            pesq: false,
            show: true,
            titulo: "Produtos",
          };

          const verProc = {
            enable: true,
            id: "verProc",
            pesq: false,
            show: true,
            titulo: "Sistema",
          };
          const valorFcp = {
            enable: true,
            id: "valorFcp",
            pesq: false,
            show: true,
            titulo: "Valor do FCP",
          };
          const valorBcst = {
            enable: true,
            id: "valorBcst",
            pesq: false,
            show: true,
            titulo: "Valor do BCST",
          };
          const data_erp = {
            enable: true,
            id: "data_erp",
            pesq: false,
            show: true,
            titulo: "Data ERP",
          };
          const departamento = {
            enable: true,
            id: "departamento",
            pesq: false,
            show: true,
            titulo: "Departamento",
          };
          const trans_cnpj = {
            enable: true,
            id: "trans_cnpj",
            pesq: true,
            show: true,
            titulo: "CNPJ da Transportadora",
          };
          const trans_nome = {
            enable: true,
            id: "trans_nome",
            pesq: true,
            show: true,
            titulo: "Nome da Transportadora",
          };
          const trans_pesoL = {
              enable: true,
              id: "trans_pesoL",
              pesq: true,
              show: true,
              titulo: "Peso Líquido (em kg)",
            };
          const trans_pesoB = {
              enable: true,
              id: "trans_pesoB",
              pesq: true,
              show: true,
              titulo: "Peso Bruto (em kg)",
          };
          const trans_esp = {
              enable: true,
              id: "trans_esp",
              pesq: true,
              show: true,
              titulo: "Espécie dos volumes transportados",
          };
          const trans_qVol = {
              enable: true,
              id: "trans_qVol",
              pesq: true,
              show: true,
              titulo: "Quantidade de volumes transportados",
          };
          const trans_modFrete = {
              enable: true,
              id: "trans_modFrete",
              pesq: true,
              show: true,
              titulo: "Modalidade do frete",
          };
          const log_statusErp = {
              enable: true,
              id: "log_statusErp",
              pesq: true,
              show: false,
              titulo: "log integração ERP",
          };
          const log_statusErpDois = {
              enable: true,
              id: "log_statusErpDois",
              pesq: true,
              show: false,
              titulo: "log integração ERP Dois",
          };
          const statusErpDois = {
              enable: true,
              id: "statusErpDois",
              pesq: false,
              show: true,
              titulo: "Status ERP Dois",
          };

          const id_fluig = {
              enable: true,
              id: "id_fluig",
              pesq: true,
              show: true,
              titulo: "Id Fluig",
          };
          const posFechamento = {
              enable: true,
              id: "posFechamento",
              pesq: true,
              show: true,
              titulo: "Pós Fechamento",
          };

          let possuiDepartamento = false;
          let possuiDocZip = false;
          let possuiNatOp = false;
          let possuiInfAd = false;
          let possuiProdutos = false;
          let possuiSistem = false;
          let possuiDataerp = false;
          let possuiFcp = false;
          let possuiBcst = false;
          let possui_trans_cnpj = false;
          let possui_trans_nome = false;
          let possui_trans_pesoL = false;
          let possui_trans_pesoB = false;
          let possui_trans_esp = false;
          let possui_trans_qVol = false;
          let possui_trans_modFrete = false;
          let possui_log_statusErp = false;
          let possui_log_statusErpDois = false;
          let possui_statusErpDois = false;
          let possuiIdFluig = false;
          let possuiPosFechamento = false;

          this.empresa[tipoHeader].forEach((header) => {
            if (header.id === "docZip") {
              possuiDocZip = true;
            }

            if (header.id === "natOp") {
              possuiNatOp = true;
            }

            if (header.id === "inf_ad") {
              possuiInfAd = true;
            }
            if (header.id === "produtos") {
              possuiProdutos = true;
            }

            if (header.id === "verProc") {
              possuiSistem = true;
            }
            if (header.id === "valorFcp") {
              possuiFcp = true;
            }
            if (header.id === "valorBcst") {
              possuiBcst = true;
            }
            if (header.id === "data_erp") {
              possuiDataerp = true;
            }
            if (header.id === "departamento") {
              possuiDepartamento = true;
            }
            if (header.id === "trans_cnpj") {
              possui_trans_cnpj = true;
            }
            if (header.id === "trans_nome") {
              possui_trans_nome = true;
            }
            if (header.id === "trans_pesoL") {
              possui_trans_pesoL = true;
            }
            if (header.id === "trans_pesoB") {
              possui_trans_pesoB = true;
            }
            if (header.id === "trans_esp") {
              possui_trans_esp = true;
            }
            if (header.id === "trans_qVol") {
              possui_trans_qVol = true;
            }
            if (header.id === "trans_modFrete") {
              possui_trans_modFrete = true;
            }
            if (header.id === "log_statusErp") {
              possui_log_statusErp = true;
            }
            if (header.id === "log_statusErpDois") {
              possui_log_statusErpDois = true;
            }
            if (header.id === "statusErpDois") {
              possui_statusErpDois = true;
            }
            if (header.id === "id_fluig") {
              possuiIdFluig = true;
            }
            if (header.id === "posFechamento") {
              possuiPosFechamento = true;
            }
          });

          // Adiciona o docZip para o header
          try {
            if (!possuiDocZip) {
              this.empresa[tipoHeader].push(docZip);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiNatOp) {
              this.empresa[tipoHeader].push(natOp);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiInfAd) {
              this.empresa[tipoHeader].push(infAd);
            }
          } catch (error) {
              console.log(error)
          }
           try {
            if (!possuiProdutos) {
              this.empresa[tipoHeader].push(produtos);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiSistem) {
              this.empresa[tipoHeader].push(verProc);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiFcp) {
              this.empresa[tipoHeader].push(valorFcp);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiBcst) {
              this.empresa[tipoHeader].push(valorBcst);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiDataerp) {
              this.empresa[tipoHeader].push(data_erp);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiDepartamento) {
              this.empresa[tipoHeader].push(departamento);
            }
          } catch (error) {
              console.log(error)
          }
          try {
              if (!possui_trans_cnpj) {
                this.empresa[tipoHeader].push(trans_cnpj);
              }
          } catch (error) {
                console.log(error)
          }
          try {
              if (!possui_trans_nome) {
                this.empresa[tipoHeader].push(trans_nome);
              }
          } catch (error) {
              console.log(error)
          }
        
          try {
            if (!possui_trans_pesoL) {
              this.empresa[tipoHeader].push(trans_pesoL);
            }
          } catch (error) {
              console.log(error)
          }

          try {
            if (!possui_trans_pesoB) {
              this.empresa[tipoHeader].push(trans_pesoB);
            }
          } catch (error) {
              console.log(error)
          }
          
          try {
            if (!possui_trans_esp) {
              this.empresa[tipoHeader].push(trans_esp);
            }
          } catch (error) {
              console.log(error)
          }

          try {
            if (!possui_trans_qVol) {
              this.empresa[tipoHeader].push(trans_qVol);
            }
          } catch (error) {
              console.log(error)
          }
          
          try {
            if (!possui_trans_modFrete) {
              this.empresa[tipoHeader].push(trans_modFrete);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possui_log_statusErp) {
              this.empresa[tipoHeader].push(log_statusErp);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possui_log_statusErpDois) {
              this.empresa[tipoHeader].push(log_statusErpDois);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possui_statusErpDois) {
              this.empresa[tipoHeader].push(statusErpDois);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiIdFluig) {
              this.empresa[tipoHeader].push(id_fluig);
            }
          } catch (error) {
              console.log(error)
          }
          try {
            if (!possuiPosFechamento) {
              this.empresa[tipoHeader].push(posFechamento);
            }
          } catch (error) {
              console.log(error)
          }
        }

        this.empresa[tipoHeader].forEach((item) => {
          let obj = {};
          obj["text"] = item.titulo;
          obj["value"] = item.id;
          obj["show"] = item.show;
          obj["pesq"] = item.pesq;
          obj["enable"] = item.enable;

          this.table.headers.push(obj);
        });
        while (i < auxNotas.length) {
          let objNfe = {};
          cont_c_column = 0;
          this.empresa[tipoHeader].forEach((item) => {
            if (
              item.id.indexOf("custom") == -1 &&
              item.id.indexOf("acoes") == -1
            ) {
              objNfe[item.id] = auxNotas[i][item.id];
              if (item.show) {
                document.querySelectorAll(`#${item.id}`).forEach((item) => {
                  item.display = "table-cell";
                  item.removeAttribute("style");
                });
              }
            } else if (item.id.indexOf("custom") != -1) {
              item.id;
              if (
                auxNotas[i].customValues != undefined &&
                auxNotas[i].customValues.length > 0 &&
                cont_c_column < auxNotas[i].customValues.length &&
                auxNotas[i].customValues[cont_c_column] != null &&
                item.id == auxNotas[i].customValues[cont_c_column].key
              ) {
                let newObjCustom = {};
                if (
                  this.component.name == "produtos" ||
                  this.component.name == "fornecedores" ||
                  this.component.name == "clientes"
                ) {
                  if (
                    auxNotas[i].customValues[cont_c_column].key.split("_")[2] ==
                    empresa_id
                  ) {
                    newObjCustom["value"] =
                      auxNotas[i].customValues[cont_c_column].value;
                    newObjCustom["key"] =
                      auxNotas[i].customValues[cont_c_column].key;
                    objNfe[item.id] = newObjCustom;
                  } else {
                    console.log(
                      "Item possui coluna customizada que não é desta empresa"
                    );
                  }
                } else {
                  newObjCustom["value"] =
                    auxNotas[i].customValues[cont_c_column].value;
                  newObjCustom["key"] =
                    auxNotas[i].customValues[cont_c_column].key;
                  objNfe[item.id] = newObjCustom;
                }

                cont_c_column++;
              } else {
                let newObjCustom = {};
                newObjCustom["value"] = "";
                newObjCustom["key"] = item.id;
                objNfe[item.id] = newObjCustom;
                cont_c_column++;
              }
            }
          });
          arrayNfe.push(objNfe);
          i++;
        }

        if (
          tipoHeader === "nfeHeaderRecebidas" ||
          tipoHeader === "nfeHeaderEmitidas"
        ) {
          return this.setDocZip(arrayNfe, auxNotas);
        } else {
          return arrayNfe;
        }
      } else {
        let auxNotas = array.slice();
        let arrayNfe = [];
        let i = 0;
        if (
          this.empresa &&
          this.empresa.servicos &&
          this.empresa.servicos.robotizacao &&
          this.empresa.servicos.robotizacao.find(
            (item) => item.nomeServico === "NFSE_TOMADOS"
          )
        ) {
          // this.pagination.sortBy = 'dataServico';
          this.table.headers = this.table.getHeaders(true);
        } else {
          this.table.headers = this.table.getHeaders();
        }
        while (i < auxNotas.length) {
          let objNfe = {};
          this.table.headers.forEach((item) => {
            if (
              item.value.indexOf("custom") == -1 &&
              item.value.indexOf("acoes") == -1
            ) {
              objNfe[item.value] = auxNotas[i][item.value];
              if (document.querySelector(`#${item.value}`)) {
                document.querySelector(`#${item.value}`).display = "table-cell";
              }
            } else if (item.value.indexOf("custom") != -1) {
              objNfe[item.value];
            }
          });
          arrayNfe.push(objNfe);
          i++;
        }

        if (
          tipoHeader === "nfeHeaderRecebidas" ||
          tipoHeader === "nfeHeaderEmitidas"
        ) {
          return this.setDocZip(arrayNfe, auxNotas);
        } else {
          return arrayNfe;
        }
        t;
      }
    },
    setDocZip(arrayNfe, auxNotas) {
      arrayNfe.map((item) => {
        auxNotas.forEach((nota) => {
          if (nota.chave === item.chave) {
            if (nota.docZip) {
              item.docZip = item.chave;
            }
          }
        });
      });
      return arrayNfe;
    },
    getOpenFiltro($event) {
      this.filtro = !this.filtro;
    },
    getSearch($event) {
      this.search = $event;
    },
    tagForSearch($event) {
      this.filtroForSearch = $event;
    },
    getLogConsulta($event) {
      this.$emit("attLogConsulta", $event);
    },
    getTextPlano(plano) {
      // return arrayPlanos.indexOf(item) != -1 ? arrayPlanos[arrayPlanos.indexOf(item)] : item}}
      let planoText = plano ? plano : "-";
      for (let i = 0; i < arrayPlanos.length; i++) {
        let item = arrayPlanos[i];
        if (item._id == plano) {
          planoText = item.text;
        }
      }
      return planoText;
    },
    emitEditEmp($event) {
      this.$emit("emitEditEmp", $event);
    },
    save: async function(nota, index) {
      if (index == "faturamento") {
        this.service = new EmpresaService(this.$http);
        this.service
          .faturamento(this.conta.conta, nota._id)
          .then((success) => {
            if (success) {
              this.snack = true;
              this.snackColor = "success";
              this.snackText = "Dado salvo";
              return true;
            }
          })
          .then((next) => {
            if (next) {
              this.table.array_todas_notas.forEach((item) => {
                if (item._id != nota._id) {
                  item.faturamento = "Não";
                }
              });
              this.table.arrayNotas = this.table.array_todas_notas.slice();
            }
          });
      } else if (index.indexOf("custom_") != -1) {
        var arrayCustomColumn = [];

        for (var prop in nota) {
          if (prop.indexOf("custom") != -1) {
            arrayCustomColumn.push(nota[prop]);
          }
        }
        this.service = new CommonService(this.$http);
        await this.service
          .saveCustomColumn(nota._id, arrayCustomColumn, this.component.name)
          .then((x) => {});
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Dado salvo";
      }
    },
    cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Cancelado";
    },
  },
};
</script>
<style scoped>
table tr {
  white-space: nowrap;
}
table tbody tr:nth-of-type(2n + 1) {
  /* background-color: #49bbad1a; */
  background-color: #e1e1e1;
}
table tbody tr:nth-of-type(2n + 2) {
  /* background-color: #49bbad1a; */
  background-color: white;
}
a {
  text-decoration: none;
}
#pagination_button {
  width: 400px;
  margin: 0 auto;
}

table.v-table tbody td:first-of-type#slctBox {
  padding: 0 10px;
}

table.v-table tbody td,
table.v-table tbody th,
table.v-table thead td,
table.v-table thead th {
  border: 2px solid #00000008;
  padding: 0px 4px !important;
}
table.v-table tbody td#status {
  padding-left: 20px !important;
}
table.v-table tbody td#tipo {
  padding-left: 20px !important;
}
table.v-table tbody td:first-of-type#slctBox,
#table td#slctBox {
  padding: 0px 4px !important;
  margin-top: 0.7px;
  /* height: 37px!important; */
}
td#emitNome {
  text-transform: uppercase;
}
td#acoes {
  padding: 0 10px;
}
#slctBox {
  padding: 0 10px;
}
table.v-table tbody tr.cancelada,
.cancelada {
  background-color: #ffe5e3;
}
.table-header .v-card__title {
  border-top: 2px solid #0000000d;
  border-bottom: 2px solid #0000000d;
}
/* .table-header .actionHeader + div + div {
  margin-bottom: 20px;
} */
.frs_header {
  padding: 0;
}

.duplicata_parcelada {
  cursor: pointer !important;
}

#showFiltrosContent {
  display: inline-block;
  margin: 10px;
}
#showFiltrosContent strong {
  color: #8f8f8f;
  font-size: 0.8em;
  font-weight: 900;
}
#showFiltrosTitle {
  margin-top: 0;
  margin-left: 0;
  display: inline-block;
  color: #979797;
  font-size: 0.8em;
  font-weight: 500;
}
#chipFiltros {
  height: 22px;
}
#chipFiltrosClose {
  font-size: 13px;
}
#table::-webkit-scrollbar {
  position: absolute;
  width: 5px;
}
#table::-webkit-scrollbar-thumb {
  background: #23578abf;
  width: 5px;
  position: absolute;
  top: 0px;
  opacity: 0.8;
  display: block;
  border-radius: 7px;
  z-index: 99;
  right: -20px;

  visibility: visible;
}
.conta_totalizar {
  width: 50%;
  font-size: 80%;
  display: inline;
}

#infoConsulta small {
  font-weight: bold;
  font-size: 66%;
}
#infoConsulta div {
  margin-top: -6px;
}
#infoConsulta i {
  font-size: 16px;
}
#infoConsulta span {
  font-size: 86%;
}
div#infoConsulta.cte {
  top: 9.9%;
  background-color: white;
}
#infoConsulta {
  text-align: center;
  position: absolute;
  right: 32px;
  border: 2px solid #cbcbcb;
  padding: 0 1.6%;
  height: 44px;
  border-radius: 6px;
  margin-top: -8px;
}

@media only screen and (max-width: 400px) {
  #pagination_button {
    width: 100%;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/CommonTable.vue